// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-quote-page.pq-page-shell {
  /* padding: 20px; */
  /* background: #f8fafc; */
  min-height: 100vh;
  font-family: "Roboto", sans-serif;
  color: #0f172a;
}

.pq-view-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 22px 24px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
}

.pq-view-title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pq-back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: #475569;
  font-size: 14px;
  font-weight: 600;
  padding: 0;
}

.pq-back-link:hover {
  color: #1d4ed8;
}

.pq-ref-divider {
  width: 1px;
  height: 20px;
  background: #d1d5db;
}

.pq-view-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
}

.pq-status-pill {
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 700;
}

.pq-page-subtitle {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 0.875rem;
  color: #495363 !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  margin-left: 74px;
}

.pq-back-link {
  box-shadow: none !important;
}


.pq-page-subtitle strong {
  color: #0f172a;
}

.pq-actions-wrap {
  position: relative;
}

.pq-btn {
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #fff;
}

.pq-btn-outline {
  border-color: #d1d5db;
  color: #334155;
  background: #fff;
}

.pq-btn-outline:hover {
  background: #f8fafc;
}

.pq-btn-primary {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.pq-btn-primary:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
}

.pq-ref-actions {
  min-width: 128px;
  height: 42px;
}

.pq-actions-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 180px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  overflow: hidden;
  z-index: 20;
}

.pq-actions-menu button {
  width: 100%;
  border: 0;
  background: transparent;
  padding: 12px 14px;
  text-align: left;
  color: #334155;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pq-actions-menu button:hover {
  background: #f8fafc;
}

.pq-layout-two-col {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 18px;
  align-items: start;
}

.pq-main-col {
  min-width: 0;
}

.pq-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
}

.pq-section-card {
  margin-bottom: 18px;
}

.pq-card-head {
  padding: 15px 18px;
  border-bottom: 1px solid #e5e7eb;
}

.pq-card-head-with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.pq-card-body {
  padding: 20px;
}

.pq-ref-card-head-blue {
  /* background: linear-gradient(to right, #eff6ff, #ffffff); */
  background: linear-gradient(to right, #eff6ff, #fff);
}

.pq-ref-card-head-indigo {
  background: linear-gradient(to right, #eef2ff, #ffffff);
}

.pq-ref-head-title {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1e3a8a;
  font-size: 15px;
  font-weight: 500;
}

.pq-agent-grid-top {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.pq-agent-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  /* border: 1px solid #e5e7eb; */
  border-radius: 12px;
  /* background: #f8fafc; */
  padding: 14px;
}

.pq-agent-item-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.pq-agent-item-icon.user {
  background: #dbeafe;
  color: #2563eb;
}

.pq-agent-item-icon.email {
  background: #e0e7ff;
  color: #4f46e5;
}

.pq-agent-item-icon.phone {
  background: #cffafe;
  color: #0891b2;
}

.pq-agent-item-icon.brokerage {
  background: #f3e8ff;
  color: #7c3aed;
}

/* .pq-k {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 4px;
} */

/* .pq-v {
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  line-height: 1.5;
} */

.pq-block-value {
  margin-top: 4px;
}

.pq-additional-btn {
  margin-top: 16px;
  width: 25%;
  height: 38px;
  padding: 0 14px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}

.pq-expand-details {
  /* margin-top: 4px; */
}

.pq-split-line {
  border-top: 1px solid #e5e7eb;
  margin: 18px 0;
}

.pq-space-top {
  margin-top: 20px;
}

.pq-agent-grid-bottom,
.pq-agent-address-grid,
.pq-meta-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

/* .pq-address-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 14px;
} */

.pq-conversation-card-body {
  padding: 0;
}

.pq-tabs-with-right {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0 18px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
}

.pq-tab {
  height: 52px;
  padding: 0 16px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: -1px;
  cursor: pointer;
  border-radius: 0;
}

.pq-tab:hover {
  background: none;
}

.pq-tab i {
  font-size: 18px;
  color: #000000;
}

.pq-tab.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
  font-weight: 700;
}

.pq-tab:not(.active):hover {
  border-bottom-color: #9ca3af;
}

.pq-tab.active i {
  color: #2563eb;
}

.pq-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 8px;
  margin-left: 6px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.pq-muted {
  color: #94a3b8;
}

.pq-mute-btn {
  margin-left: auto;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: #000000;
  font-size: 13px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.pq-mute-btn i {
  color: #94a3b8;
}

.pq-mute-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.pq-mute-btn.pq-mute-btn-active {
  border-color: #fdba74;
  background: #fff7ed;
  color: #c2410c;
}

.pq-mute-btn.pq-mute-btn-active i {
  color: #ea580c;
}

.pq-convo-list,
.pq-shared-files {
  padding: 18px;
}

/* Per-message white cards removed — see "conversation area final override" */

.pq-convo-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 12px;
}

.pq-convo-user {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pq-convo-avatar {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-convo-avatar.agent {
  background: #dbeafe;
  color: #2563eb;
}

.pq-convo-avatar.designer {
  background: #ede9fe;
  color: #7c3aed;
}

.pq-convo-user-meta strong {
  display: inline;
  font-size: 14px;
  color: #111827;
  line-height: 1.25;
}

.pq-convo-role {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.pq-convo-time {
  font-size: 12px;
  color: #64748b;
}

.pq-convo-top-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pq-reply-btn {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.pq-reply-inline {
  border-left: 3px solid #93c5fd;
  background: #eff6ff;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pq-reply-inline strong {
  font-size: 12px;
  color: #1d4ed8;
}

.pq-reply-inline span {
  font-size: 13px;
  color: #475569;
}

.pq-convo-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: #334155;
  white-space: pre-wrap;
}

.pq-attachments {
  margin-top: 14px;
  display: grid;
  gap: 10px;
}

.pq-attachment {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  background: #f8fafc;
}

.pq-attachment-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.pq-attachment-fileicon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #eef2ff;
  color: #4f46e5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-attachment-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.pq-attachment-download {
  width: 34px;
  height: 34px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #334155;
}

.pq-convo-input-wrap {
  /* border-top: 1px solid #e5e7eb; */
  padding: 18px;
  background: #fff;
}

.pq-replying-bar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 14px;
}

.pq-replying-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.pq-replying-meta strong {
  font-size: 13px;
  color: #1d4ed8;
}

.pq-replying-meta span {
  font-size: 13px;
  color: #475569;
}

.pq-replying-cancel {
  border: 0;
  background: transparent;
  color: #64748b;
  font-size: 18px;
}

.pq-msg-input {
  width: 100%;
  min-height: 110px;
  resize: vertical;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 14px;
  color: #0f172a;
  outline: none;
}

.pq-msg-input::placeholder {
  color: #94a3b8;
}

.pq-msg-input:focus {
  border-color: #93c5fd;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);
}

.pq-attached-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.pq-attached-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  color: #1e3a8a;
  border-radius: 999px;
  padding: 8px 10px;
  font-size: 12px;
}

.pq-attached-pill-name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pq-attached-pill-size {
  color: #64748b;
}

.pq-attached-pill-remove {
  width: 20px;
  height: 20px;
  border: 0;
  border-radius: 999px;
  background: #dbeafe;
  color: #1d4ed8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-msg-actions--composer {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  /* margin-top: 16px; */
}

.pq-msg-actions-left {
  display: flex;
  align-items: center;
}

.pq-btn-sm {
  height: 38px;
  padding: 0 14px;
}

.pq-attach-label {
  margin: 0;
}

.pq-msg-toolbar-divider {
  width: 1px;
  align-self: stretch;
  background: #e5e7eb;
}

.pq-design-proof-block {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pq-design-proof-label {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}

.pq-design-proof-toggles {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pq-toggle-yesno {
  height: 34px;
  padding: 0 14px;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #fff;
  color: #475569;
  font-size: 13px;
  font-weight: 600;
}

.pq-toggle-yesno.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.pq-msg-toolbar-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

/* 
.pq-emoji-inline-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: #475569;
} */

.pq-attached-count-text {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
}

.pq-send-btn {
  height: 40px;
  padding: 0 16px;
  margin-left: 0;
}

.pq-proof-group {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}

.pq-proof-group+.pq-proof-group {
  margin-top: 14px;
}

.pq-proof-group-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 13px;
  font-weight: 700;
}

.pq-proof-group-head.plain {
  background: #f8fafc;
  color: #475569;
}

.pq-proof-chip {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: #c7d2fe;
  color: #3730a3;
  font-size: 12px;
  font-weight: 700;
}

.pq-file-row {
  display: grid;
  grid-template-columns: 52px 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 14px;
  border-top: 1px solid #eef2f7;
}

.pq-file-type {
  min-width: 46px;
  height: 30px;
  border-radius: 8px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-file-type.png,
.pq-file-type.jpg,
.pq-file-type.jpeg {
  background: #dbeafe;
  color: #1d4ed8;
}

.pq-file-meta {
  min-width: 0;
}

.pq-file-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  word-break: break-word;
}

.pq-file-sub {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  font-size: 0.875rem;
  color: #495363 !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  margin-top: 2px;
}

.pq-file-sub-name {
  font-weight: 600;
  color: #334155;
}

.pq-file-sub-role {
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.pq-file-sub-time {
  color: #64748b;
  font-size: 12px;
}

.pq-file-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #94a3b8;
}

.pq-file-actions a,
.pq-file-actions .pq-file-action-btn,
.pq-file-actions i {
  font-size: 18px;
  color: #64748b;
}

.pq-file-actions .pq-file-action-btn {
  border: none;
  background: transparent;
  padding: 0;
  line-height: 1;
  cursor: pointer;
}

.pq-sticky-side {
  position: sticky;
  top: 18px;
  overflow: visible;
}

.pq-sidebar-body {
  padding: 18px;
}

.pq-workflow-timeline {
  list-style: none;
  padding: 0;
  margin: 0;
}

.pq-workflow-item {
  position: relative;
  display: flex;
  gap: 12px;
  padding-bottom: 20px;
}

.pq-workflow-item:not(:last-child)::after {
  content: "";
  position: absolute;
  left: 14px;
  top: 32px;
  bottom: 0;
  width: 2px;
  background: #e5e7eb;
}

.pq-workflow-dot {
  position: relative;
  z-index: 1;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pq-workflow-dot.done {
  background: #dcfce7;
  color: #16a34a;
}

.pq-workflow-dot.progress {
  background: #ede9fe;
  color: #7c3aed;
}

.pq-workflow-dot.pending {
  background: #f3f4f6;
  color: black;
}

.pq-wf-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.pq-wf-sub {
  font-size: 0.875rem;
  color: #495363 !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  margin-top: 2px;
}

.pq-wf-sub.done {
  color: #16a34a;
}

.pq-wf-sub.progress {
  color: #7c3aed;
}

.pq-wf-extra {
  margin-top: 4px;
  font-size: 0.875rem;
  color: #495363 !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
}

.pq-side-section {
  margin-top: 18px;
  padding-top: 18px;
  border-top: 1px solid #e5e7eb;
}

.pq-side-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: #166534;
}

.pq-side-box {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  padding: 14px;
  margin-bottom: 14px;
}

.pq-side-box-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 800;
  color: #334155;
  letter-spacing: 0.03em;
}

.pq-radio-row {
  display: grid;
  grid-template-columns: 18px 1fr auto;
  gap: 12px;
  align-items: start;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  background: #fff;
  margin-bottom: 10px;
}

.pq-radio-row.selected {
  border-color: #93c5fd;
  background: #eff6ff;
}

.pq-radio-row input {
  margin-top: 4px;
}

.pq-proof-option-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pq-proof-label {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.pq-proof-file-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: fit-content;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  font-size: 12px;
  color: #4b5563;
}

.pq-full-btn {
  width: 100%;
  margin-top: 4px;
  height: 42px;
}

.pq-btn-disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.pq-required {
  color: #ef4444;
}

.pq-order-option {
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 12px;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px;
  background: #fff;
  margin-bottom: 10px;
}

.pq-order-option input {
  margin: 0;
}

.pq-order-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pq-order-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  flex-shrink: 0;
}

.pq-order-row strong {
  display: block;
  font-size: 14px;
  color: #111827;
  margin-bottom: 2px;
}

.pq-order-row small {
  font-size: 0.875rem;
  color: #495363 !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
}

.pq-cancel-btn {
  color: #dc2626;
  border-color: #fecaca;
  background: #fff5f5;
}

.pq-cancel-btn:hover {
  background: #fef2f2;
}

@media (max-width: 1200px) {
  .pq-layout-two-col {
    grid-template-columns: 1fr;
  }

  .pq-sticky-side {
    position: static;
  }
}

@media (max-width: 768px) {
  .project-quote-page.pq-page-shell {
    padding: 14px;
  }

  .pq-view-head {
    flex-direction: column;
    align-items: stretch;
    padding: 18px;
  }

  .pq-ref-divider {
    display: none;
  }

  .pq-agent-grid-top,
  .pq-agent-grid-bottom,
  .pq-agent-address-grid,
  .pq-meta-row {
    grid-template-columns: 1fr;
  }

  .pq-agent-address-row--city-state-zip {
    grid-template-columns: 1fr;
  }

  .pq-tabs-with-right {
    flex-wrap: wrap;
    padding-bottom: 10px;
  }

  .pq-mute-btn {
    margin-left: 0;
  }

  .pq-convo-top {
    flex-direction: column;
    align-items: flex-start;
  }

  .pq-msg-actions--composer {
    flex-direction: column;
    align-items: stretch;
  }

  .pq-msg-toolbar-divider {
    display: none;
  }

  .pq-msg-toolbar-meta {
    margin-left: 0;
    justify-content: space-between;
  }

  .pq-send-btn,
  .pq-attach-label {
    width: 100%;
    justify-content: center;
  }

  .pq-file-row {
    grid-template-columns: 1fr;
  }
}


/* ===== Reference matching overrides ===== */
.project-quote-page.pq-page-shell {
  box-sizing: border-box;
  width: 100%;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 clamp(16px, 3vw, 40px) 28px;
  /* background: #f3f4f6; */
}

.pq-layout-two-col {
  grid-template-columns: minmax(0, 1fr) 430px;
  gap: 24px;
  align-items: start;
}

.pq-view-head,
.pq-card {
  border-color: #d8dee8;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
}

.pq-view-head {
  padding: 22px 28px;
  margin-bottom: 20px;
}

.pq-view-title {
  font-size: 24px;
  line-height: 1.2;
}


.pq-card-head {
  padding: 16px 22px;
  background: #f3f6fc;
  border-radius: 15px 15px 0px 0px;
}

/* .pq-ref-card-head-blue,
.pq-ref-card-head-indigo {
  background: #f3f6fc;
} */

/* .pq-ref-head-title {
  color: #2f4fd2;
  font-size: 16px;
  font-weight: 700;
} */

.pq-ref-head-title i {
  font-size: 18px;
}

.pq-card-body {
  padding: 20px 22px;
}

.pq-agent-grid-top {
  gap: 14px;
}

.pq-agent-item {
  /* min-height: 78px; */
  padding: 15px 18px;
  /* background: #ffffff;
  border-color: #d8dee8;
  border-radius: 14px; */
}

.pq-agent-item-icon {
  width: 42px;
  height: 42px;
  border-radius: 999px;
  font-size: 20px;
}


.pq-agent-item-icon.user {
  background: #dbeafe;
  color: #2d63f6;
}

.pq-agent-item-icon.email {
  background: #d9f0fb;
  color: #0ea5d7;
}

.pq-agent-item-icon.phone {
  background: #d8f3df;
  color: #1fad5d;
}

.pq-agent-item-icon.brokerage {
  background: #ffe9c8;
  color: #ff7a1a;
}

.pq-k {
  /* font-size: 0.75rem;
    line-height: 1rem;
  text-transform: uppercase;
  color: #64748b;
  font-weight: 500; */
  margin-bottom: 4px;
  font-size: 0.875rem;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  /* font-weight: 500 !important; */
}

.pq-v {
  font-size: 0.875rem;
  color: #495363 !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  /* font-size: 0.875rem;
    line-height: 1.25rem;
  font-weight: 500;
  color: #111827;
  --tw-text-opacity: 1; */
}

/* .pq-additional-btn {
  width: 100%;
  height: 42px;
  margin-top: 14px;
  border-radius: 12px;
  border-color: #cfd7e3;
  font-weight: 700;
} */

.pq-split-line {
  border-top-color: #e2e8f0;
  margin: 18px 0;
}

.pq-address-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  /* font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #0f172a; */
  font-size: 0.875rem;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  font-weight: 500 !important;
}

.pq-address-heading i {
  font-size: 16px;
  color: #475569;
}

.pq-agent-address-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.pq-agent-address-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pq-agent-address-field {
  min-width: 0;
}

.pq-agent-address-row {
  display: grid;
  gap: 16px 24px;
}

.pq-agent-address-row--city-state-zip {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.pq-agent-address-row--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.pq-agent-address-row--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.pq-k {
  /* font-size: 0.75rem;
    line-height: 1rem;
  text-transform: uppercase;
  color: #64748b;
  font-weight: 500; */
  margin-bottom: 4px;
  font-size: 0.875rem;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  /* font-weight: 500 !important; */
}

.pq-v {
  font-size: 0.875rem;
  color: #000000 !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  font-weight: 500 !important;
  /* font-size: 0.875rem;
    line-height: 1.25rem;
  font-weight: 500;
  color: #111827;
  --tw-text-opacity: 1; */
}

.pq-agent-address-section .pq-k {
  /* display: block;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em; */

  margin-bottom: 4px;
  font-size: 0.875rem;
  color: #111827;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  /* font-weight: 500 !important; */
}

.pq-agent-address-section .pq-v {
  /* font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.45; */
  font-size: 0.875rem;
  color: black !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
}

.pq-meta-row,
.pq-agent-address-grid {
  gap: 20px;
}

/* Single column by default; wider breakpoints restore 2–3 columns (must not override mobile). */
.pq-agent-grid-bottom {
  grid-template-columns: 1fr;
  gap: 20px;
}

@media (min-width: 640px) {
  .pq-agent-grid-bottom {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .pq-agent-grid-bottom {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

/* Duplicate .pq-tabs / .pq-mute rules removed — defined above + "conversation area final override" */

.pq-convo-input-wrap {
  /* border-top: 1px solid #e2e8f0; */
  padding: 18px;
}

.pq-msg-input {
  min-height: 108px;
  border-radius: 14px;
  border-color: #cfd7e3;
}

.pq-msg-actions--composer {
  justify-content: space-between;
  gap: 14px;
}

.pq-btn,
.pq-order-option,
.pq-radio-row,
.pq-side-box,
.pq-msg-input,
.pq-proof-group,
.pq-attachment,
.pq-file-row {
  border-radius: 14px;
}

.pq-sticky-side {
  position: sticky;
  top: 16px;
  align-self: start;
  max-height: none;
  overflow: visible;
}

.pq-sidebar-body {
  padding: 18px 22px 22px;
  max-height: none;
  overflow: visible;
}

.pq-workflow-timeline {
  margin-bottom: 8px;
}

.pq-workflow-item {
  gap: 16px;
  padding-bottom: 28px;
}

.pq-workflow-item.is-dim {
  opacity: 1;
}

.pq-workflow-item:not(:last-child)::after {
  left: 15px;
  top: 32px;
  background: #d6dce5;
}

.pq-workflow-dot {
  width: 32px;
  height: 32px;
  border: 2px solid transparent;
}

.pq-workflow-dot.done {
  background: #d7f2dc;
  color: #1ea854;
}

.pq-workflow-dot.progress {
  background: #efddff;
  color: #8a4df2;
  border-color: #c89ef7;
}

.pq-workflow-dot.pending {
  background: #f3f4f6;
  color: #b4bcc8;
}

.pq-workflow-dot.current-approved {
  background: #d7f2dc;
  color: #1ea854;
  border-color: #9be2ab;
}

.pq-workflow-dot.current-quoted {
  background: #ffedd8;
  color: #f97316;
  border-color: #f6bf8b;
}

.pq-wf-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  margin-top: 2px;
}

/* .pq-wf-sub {
  margin-top: 4px;
  font-size: 13px;
  color: #a0a8b6;
} */

.pq-wf-sub.done {
  color: #1ea854;
}

.pq-wf-sub.progress {
  color: #8a4df2;
}

.pq-wf-sub.current-approved {
  color: #1ea854;
}

.pq-wf-sub.current-quoted {
  color: #f97316;
}


.pq-wf-link-row {
  margin-top: 8px;
  font-size: 12px;
  color: #718096;
}

.pq-linked-quote-btn {
  border: 0;
  background: transparent;
  color: #2d63f6;
  font-weight: 700;
  padding: 0;
  margin-left: 4px;
}

.pq-side-section {
  margin-top: 10px;
  padding-top: 20px;
  border-top-color: #d8dee8;
}

.pq-side-title {
  font-size: 15px;
  font-weight: 800;
  color: #146534;
}

.pq-side-box {
  border-color: #d8dee8;
  padding: 0;
  overflow: hidden;
  margin-bottom: 16px;
}

.pq-side-box-title {
  margin: 0;
  padding: 14px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 12px;
  font-weight: 800;
}

.pq-side-box>.text-muted,
.pq-side-box>.pq-btn,
.pq-side-box>.pq-order-option,
.pq-side-box>.pq-radio-row {
  margin-left: 16px;
  margin-right: 16px;
}

.pq-side-box>.text-muted {
  margin-top: 14px;
}

.pq-radio-row,
.pq-order-option {
  border-color: #d8dee8;
  min-height: 82px;
  margin-bottom: 12px;
}

.pq-radio-row:first-of-type,
.pq-order-option:first-of-type {
  margin-top: 14px;
}

.pq-radio-row.selected {
  border-color: #99c1ff;
  background: #eff6ff;
}

.pq-radio-row.approved {
  background: #f0fdf4;
  border-color: #b8e7c1;
}

.pq-proof-approved-text {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background: #dcfce7;
  color: #15803d;
  font-size: 11px;
  font-weight: 700;
}

.pq-proof-file-chip {
  background: #f8fafc;
}

.pq-order-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
}

.pq-full-btn {
  width: calc(100% - 32px);
  margin: 0 16px 16px;
  height: 46px;
  border-radius: 12px;
  background: #2563eb;
  color: #fff;
}

.pq-full-btn-cancel {
  width: calc(100% - 32px);
  margin: 0 16px 16px;
  height: 46px;
  border-radius: 12px;
}

.pq-full-btn:hover {
  background: #1d4ed8 !important;
  color: #fff !important;
}

.pq-btn-disabled {
  opacity: .55;
}

.pq-cancel-btn {
  background: #fff7f7;
  border-color: #f7b9b9;
  color: #e3342f;
}

.pq-status-pill.inprogress {
  background: #cffafe;
  color: #0e7490;
}

.pq-status-pill.approved {
  background: #dcfce7;
  color: #15803d;
}

.pq-status-pill.quoted {
  background: #ffedd5;
  color: #c2410c;
}

.pq-status-pill.quote-approved {
  background: #dbeafe;
  color: #1d4ed8;
}

.pq-status-pill.completed {
  background: #e5e7eb;
  color: #374151;
}

@media (max-width: 1200px) {
  .pq-layout-two-col {
    grid-template-columns: 1fr;
  }

  .pq-sticky-side {
    position: static;
  }
}

@media (max-width: 768px) {
  .project-quote-page.pq-page-shell {
    padding: 14px;
  }

  .pq-view-head {
    padding: 18px;
  }

  .pq-view-title {
    font-size: 20px;
  }

  .pq-card-body,
  .pq-card-head,
  .pq-sidebar-body {
    padding-left: 16px;
    padding-right: 16px;
  }

  .pq-agent-item,
  .pq-radio-row,
  .pq-order-option {
    min-height: auto;
  }

  .pq-side-box>.pq-btn,
  .pq-side-box>.pq-order-option,
  .pq-side-box>.pq-radio-row,
  .pq-side-box>.text-muted {
    margin-left: 12px;
    margin-right: 12px;
  }

  .pq-full-btn {
    width: calc(100% - 24px);
    margin-left: 12px;
    margin-right: 12px;
  }
}

/* --- conversation area final override (reference UI) --- */
.pq-conversation-card-body {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: 0;
}

/* Tabs: clear active / inactive (overrides earlier rules) */
.pq-tabs-with-right {
  flex-shrink: 0;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}

/* .pq-tab {
  height: 52px;
  padding: 0 16px;
  margin-bottom: -1px;
  border-bottom: 3px solid transparent;
  color: #000000;
  font-weight: 500;
} */

.pq-tab:not(.active):hover {
  color: #475569;
}

.pq-tab.active {
  color: #2563eb;
  border-bottom-color: #2563eb;
}

.pq-tab-badge {
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.pq-convo-list {
  flex: 1 1 auto;
  min-height: 140px;
  max-height: min(480px, 55vh);
  padding: 16px 18px 18px;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}

.pq-shared-files {
  flex: 1 1 auto;
  min-height: 140px;
  max-height: min(480px, 55vh);
  padding: 16px 18px 18px;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-gutter: stable;
}

.pq-convo-item {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0 0 6px;
  margin: 0;
}

.pq-convo-item+.pq-convo-item {
  padding-top: 16px;
  /* border-top: 1px solid #e5e7eb; */
}

.pq-convo-top {
  margin-bottom: 10px;
  align-items: center;
}

.pq-convo-user {
  align-items: center;
  min-width: 0;
}

.pq-convo-user-meta {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}

.pq-convo-user-meta strong {
  display: inline;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.25;
}

.pq-convo-role {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.pq-convo-time {
  font-size: 12px;
  color: #000000;
  white-space: nowrap;
}

/* Reply: visible next to timestamp (was hidden for an older reference mock) */
.pq-reply-btn {
  height: 32px;
  padding: 0 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #2563eb;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-shrink: 0;
  cursor: pointer;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
}

.pq-reply-btn:hover {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
}

.pq-reply-btn:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

.pq-reply-btn i {
  font-size: 16px;
  line-height: 1;
}

@media (max-width: 480px) {
  .pq-reply-btn .pq-reply-btn-text {
    display: none;
  }

  .pq-reply-btn {
    padding: 0 10px;
    min-width: 36px;
  }
}

.pq-convo-avatar.agent {
  background: #eceff3;
  color: black;
}

.pq-convo-avatar.designer {
  background: #dbeafe;
  color: #2563eb;
}

/* Full-width gray bubble under header row (reference) */
.pq-convo-bubble-wrap {
  margin-left: 43px !important;
  width: 95%;
  max-width: 100%;
}

.pq-convo-bubble-body {
  border-radius: 12px;
  background: #f3f4f6;
  overflow: hidden;
}

.pq-convo-bubble-body--admin {
  background: #dbeafe;
}

.pq-convo-bubble-body--agent {
  background: #f3f4f6;
}

.pq-convo-bubble-body .pq-convo-text {
  background: transparent;
  border-radius: 0;
}

.pq-convo-bubble-body .pq-attachments {
  margin-top: 0;
  padding: 0 14px 14px;
}

/* Approved proof bundle in conversation (message.approved_by + reply_to_files) */
.pq-msg-proof-approved {
  margin: 14px 14px 14px;
  /* border: 1px solid #008000; */
  border-radius: 12px;
  background: linear-gradient(180deg, #f0fdf4 0%, #ecfdf5 100%);
  overflow: hidden;
}

.pq-msg-proof-approved-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 14px;
  border-bottom: 1px solid #bbf7d0;
  background: rgba(255, 255, 255, 0.65);
}

.pq-msg-proof-approved-head-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.pq-msg-proof-version-pill {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid #22c55e;
  background: #fff;
  color: #15803d;
  font-size: 12px;
  font-weight: 800;
}

.pq-msg-proof-file-count {
  font-size: 13px;
  font-weight: 700;
  color: #166534;
}

.pq-msg-proof-approved-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  background: #367C2B;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
}

.pq-msg-proof-approved-pill i {
  font-size: 14px;
  line-height: 1;
}

.pq-msg-proof-by {
  font-size: 13px;
  font-weight: 700;
  color: #15803d;
  white-space: nowrap;
}

.pq-msg-proof-by--stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  max-width: 100%;
  white-space: normal;
}

.pq-msg-proof-by-line {
  display: block;
  line-height: 1.35;
  text-align: right;
}

.pq-msg-proof-by-line--secondary {
  font-weight: 600;
  color: #166534;
}

.pq-msg-proof-rows {
  display: flex;
  flex-direction: column;
}

.pq-msg-proof-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-top: 1px solid #bbf7d0;
  background: #f8fffb;
}

.pq-msg-proof-row:first-of-type {
  border-top: none;
}

.pq-msg-proof-row-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1 1;
}

.pq-msg-proof-row-icon {
  font-size: 20px;
  color: #22c55e;
  flex-shrink: 0;
}

.pq-msg-proof-row-letter {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  border-radius: 8px;
  background: #dcfce7;
  color: #166534;
  font-size: 11px;
  font-weight: 800;
}

.pq-msg-proof-row-name {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pq-msg-proof-row-download {
  box-sizing: border-box;
  width: 30px;
  height: 30px;
  padding: 0;
  margin: 0;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #f9fafb;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
  text-decoration: none;
}

.pq-msg-proof-row-download:hover {
  background: #ecfdf5;
  border-color: #86efac;
  color: #15803d;
}

.pq-msg-proof-row-download svg,
.pq-msg-proof-row-download i {
  display: block;
  font-size: 18px;
}

.pq-msg-proof-row-download--disabled {
  opacity: 0.45;
  pointer-events: none;
}

.pq-msg-proof-head-doc {
  font-size: 20px;
  color: #15803d;
  flex-shrink: 0;
}

.pq-msg-proof-row--rich {
  align-items: stretch;
}

.pq-msg-proof-row-inner {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.pq-msg-proof-row-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.pq-msg-proof-row-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.pq-msg-proof-row-view {
  box-sizing: border-box;
  width: 30px;
  height: 30px;
  padding: 0;
  margin: 0;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #f9fafb;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
  cursor: pointer;
}

.pq-msg-proof-row-view:hover {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #2563eb;
}

.pq-msg-proof-row-view i {
  font-size: 18px;
}

.pq-msg-proof-row-sub {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  padding-left: 2px;
}

.pq-msg-proof-row-sub--enduser {
  align-items: flex-start;
  gap: 8px;
}

.pq-msg-proof-row-sub-ico {
  flex-shrink: 0;
  margin-top: 2px;
}

.pq-msg-proof-row-sub-lines {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
  color: #475569;
  font-weight: 600;
}

.pq-msg-proof-row-sub-brokerage {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  line-height: 1.35;
}

.pq-msg-proof-row-sub-meta {
  margin-left: auto;
  flex-shrink: 0;
  color: #64748b;
  font-weight: 600;
}

.pq-msg-proof-row-sub i {
  font-size: 14px;
  color: #94a3b8;
}

.pq-msg-proof-row-sub-dot {
  color: #cbd5e1;
}

.pq-msg-proof-file-approved-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  background: #22c55e;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  flex-shrink: 0;
}

.pq-msg-proof-file-approved-pill i {
  font-size: 13px;
}

.pq-msg-proof-row-main--shared {
  flex-wrap: wrap;
  align-items: center;
}

.pq-msg-proof-row-main--shared .pq-file-type {
  flex-shrink: 0;
}

.pq-proof-group--proof-chat {
  border: none;
  background: transparent;
  overflow: visible;
}

.pq-msg-proof-approved--embedded {
  margin: 0;
}

.pq-msg-proof-approved--embedded .pq-msg-proof-approved-head {
  border-radius: 12px 12px 0 0;
}

.pq-msg-proof-approved--embedded .pq-msg-proof-rows {
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

.pq-shared-file-delete {
  color: #b91c1c;
  border-color: #fecaca;
  background: #fef2f2;
}

.pq-shared-file-delete:hover {
  background: #fee2e2;
  border-color: #fca5a5;
  color: #991b1b;
}

/* File preview modal (signage project view — proof / shared files) */
.pq-file-preview-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10800;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.pq-file-preview-modal {
  width: min(920px, 100%);
  max-height: min(90vh, 880px);
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pq-file-preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.pq-file-preview-title-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.pq-file-preview-title-wrap>i {
  font-size: 22px;
  color: #64748b;
  flex-shrink: 0;
}

.pq-file-preview-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pq-file-preview-close {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  background: #f1f5f9;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}

.pq-file-preview-close:hover {
  background: #e2e8f0;
}

.pq-file-preview-body {
  flex: 1 1;
  min-height: 200px;
  max-height: min(62vh, 640px);
  background: #0f172a;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.pq-file-preview-img {
  max-width: 100%;
  max-height: min(58vh, 600px);
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
}

.pq-file-preview-fallback {
  text-align: center;
  color: #94a3b8;
  padding: 40px 24px;
}

.pq-file-preview-fallback i {
  font-size: 48px;
  display: block;
  margin-bottom: 12px;
  opacity: 0.85;
}

.pq-file-preview-fallback p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.pq-file-preview-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  background: #fafafa;
}

.pq-file-preview-meta {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
}

.pq-file-preview-download {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 18px;
  border: none;
  border-radius: 10px;
  background: #2563eb;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.pq-file-preview-download:hover {
  background: #1d4ed8;
}

.pq-file-preview-download svg {
  flex-shrink: 0;
  color: inherit;
}

/* Lucide icons in file rows (match prior Remix icon sizing) */
.pq-msg-proof-row-view .sqbtn__icon svg,
.pq-msg-proof-row-download .sqbtn__icon svg {
  width: 18px;
  height: 18px;
}

.pq-file-actions .sqbtn__icon svg {
  width: 18px;
  height: 18px;
}

.pq-attachment-download .sqbtn__icon svg {
  width: 18px;
  height: 18px;
}

.pq-convo-text {
  font-size: 0.875rem;
  color: #495363 !important;
  letter-spacing: -.025em;
  font-family: Roboto, sans-serif;
  padding: 14px 16px;
  border: none;
  border-radius: 12px;
  background: #f3f4f6;
  white-space: pre-wrap;
}



.pq-convo-item.pq-convo-item--reply-target {
  border-radius: 12px;
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
  background: #f8fafc;
}

.pq-convo-item .pq-attachment {
  background: #fff;
  border: 1px solid #e5e7eb;
  width: 70%;
}

.pq-convo-item .pq-attachment-content {
  min-width: 0;
}

.pq-convo-item .pq-attachment-topline {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.pq-convo-item .pq-attachment-proof-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  background: #e9d5ff;
  color: #6b21a8;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.pq-convo-item a.pq-attachment-download {
  text-decoration: none;
  color: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-convo-item .pq-attachment-download--disabled {
  opacity: 0.45;
  pointer-events: none;
}

/* Composer card: segmented sections + toolbar row (reference image 2) */
.pq-convo-input-wrap {
  padding: 0;
  /* flex-shrink: 0;
  margin: 0 18px 18px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06); */
  overflow: hidden;
}

.pq-convo-input-wrap::before {
  display: none;
}

.pq-composer-section--reply {
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  background: #fafafa;
}

.pq-composer-section--text {
  padding: 16px 18px;
  /* border-bottom: 1px solid #e5e7eb; */
}

.pq-composer-section--attachments {
  padding: 12px 18px 14px;
  border-top: 1px solid #e5e7eb;
  /* background: #fafafa; */
}

.pq-msg-input {
  box-sizing: border-box;
  width: 100%;
  min-height: 112px;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  color: #0f172a;
  font-size: 14px;
  line-height: 1.55;
  resize: vertical;
  box-shadow: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.pq-msg-input:hover {
  border-color: #d1d5db;
}

.pq-msg-input:focus {
  outline: none;
  border-color: #93c5fd;
  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.25);
}

.pq-msg-input::placeholder {
  color: #9ca3af;
  font-size: 14px;
}

.pq-composer-section--attachments .pq-attached-list {
  margin-top: 0;
}

.pq-attached-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.pq-attached-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 8px 10px 8px 12px;
  border: 1px solid #93c5fd;
  border-radius: 999px;
  background: #f0f7ff;
  font-size: 13px;
  font-weight: 500;
  color: #1e40af;
}

.pq-attached-pill>i.ri-file-2-line {
  flex-shrink: 0;
  font-size: 16px;
  color: #3b82f6;
}

.pq-attached-pill-name {
  color: #1d4ed8;
  font-weight: 600;
  max-width: min(240px, 55vw);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pq-attached-pill-size {
  flex-shrink: 0;
  color: #60a5fa;
  font-size: 12px;
  font-weight: 500;
}

.pq-attached-pill-remove {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-left: 2px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: rgba(59, 130, 246, 0.15);
  color: #2563eb;
  cursor: pointer;
  transition: background 0.15s ease;
}

.pq-attached-pill-remove:hover {
  background: rgba(59, 130, 246, 0.28);
}

.pq-msg-actions--composer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px 16px 14px;
  flex-wrap: wrap;
}

.pq-msg-toolbar-flow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 12px;
  flex: 1 1 auto;
  min-width: 0;
}

.pq-design-proof-block {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin: 0;
}

.pq-design-proof-label {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
  white-space: nowrap;
}

.pq-design-proof-toggles {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.pq-toggle-yesno {
  height: 36px;
  padding: 0 16px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: #4b5563;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.pq-toggle-yesno:hover {
  border-color: #9ca3af;
  background: #f9fafb;
}

.pq-toggle-yesno.active {
  background: #fff;
  border-color: #2563eb;
  color: #2563eb;
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.35);
}

.pq-attach-label {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  margin: 0 !important;
  padding: 0 16px !important;
  border: 1px solid #d1d5db !important;
  border-radius: 12px !important;
  background: #fff !important;
  color: black !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  cursor: pointer;
  box-shadow: none !important;
}

.pq-attach-label:hover {
  background: #f9fafb !important;
  border-color: #cbd5e1 !important;
  color: #475569 !important;
}

.pq-msg-toolbar-divider--vertical {
  width: 1px;
  height: 28px;
  background: #e2e8f0;
  flex-shrink: 0;
}

.pq-msg-toolbar-flow .pq-attached-count-text {
  color: black;
  font-size: 13px;
  font-weight: 500;
  margin-left: 2px;
  white-space: nowrap;
}

.pq-emoji-inline-btn {
  width: 109px;
  min-width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: black;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.pq-emoji-inline-btn:hover {
  background: #f9fafb;
  border-color: #cbd5e1;
}

.pq-emoji-inline-btn-proof {
  width: 36px;
  min-width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #fff;
  color: black;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.pq-emoji-inline-btn-proof:hover {
  background: #f9fafb;
  border-color: #cbd5e1;
}


.pq-convo-input-wrap .pq-send-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  min-width: 104px;
  height: 44px;
  padding: 0 18px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  background: #1d4ed8 !important;
  border: 1px solid #7c9fe8 !important;
  color: #fff !important;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.2);
}

.pq-convo-input-wrap .pq-send-btn:hover:not(:disabled) {
  background: #1d4ed8 !important;
  border-color: #7c9fe8 !important;
}

.pq-convo-input-wrap .pq-send-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pq-emoji-picker-wrap {
  position: relative;
}

.pq-emoji-picker-pop {
  position: absolute;
  left: 0;
  bottom: calc(100% + 10px);
  width: 390px;
  max-width: min(390px, calc(100vw - 48px));
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.14);
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 6px;
  z-index: 40;
}

.pq-emoji-pick-btn {
  height: 36px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font-size: 23px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-emoji-pick-btn:hover {
  background: #f1f5f9;
}

.pq-send-btn {
  min-width: 104px;
  height: 44px;
  padding: 0 18px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 700;
  flex: 0 0 auto;
}

@media (max-width: 768px) {
  .pq-convo-top-actions {
    width: 100%;
    justify-content: space-between;
  }



  .pq-msg-actions--composer {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .pq-msg-toolbar-flow {
    width: 100%;
  }

  .pq-convo-input-wrap .pq-send-btn {
    width: 100%;
    justify-content: center;
  }

  .pq-emoji-picker-pop {
    left: 0;
    width: min(320px, calc(100vw - 48px));
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}

/* ---- Project Workflow v2 (status-aware stepper, SignageViewprojectandquote) ---- */
.pq-workflow-timeline--v2 {
  position: relative;
}

.pq-workflow-timeline--v2::before {
  display: none !important;
}

.pq-workflow-timeline--v2 .pq-workflow-item {
  position: relative;
  display: flex;
  gap: 12px;
  padding-bottom: 20px;
  align-items: flex-start;
}

.pq-workflow-timeline--v2 .pq-workflow-item:not(:last-child)::after {
  content: "";
  position: absolute;
  left: 14px;
  top: 39px;
  bottom: -10px;
  width: 2px;
  background: #e5e7eb;
  z-index: 0;
}

.pq-workflow-timeline--v2 .pq-workflow-item.pq-wf-connector-green:not(:last-child)::after {
  background: #16a34a;
}

.pq-workflow-timeline--v2 .pq-workflow-item.pq-wf-connector-gray:not(:last-child)::after {
  background: #e5e7eb;
}

.pq-workflow-timeline--v2 .pq-workflow-dot {
  position: relative;
  z-index: 1;
  width: 30px;
  height: 30px;
  min-width: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  font-size: 15px;
  line-height: 1;
}

/* Stage color = circle + icon + connector; status text stays neutral grey (see .pq-wf-sub-*) */
.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-done {
  background: #e6f4ea;
  color: #1e8e3e;
  border: 1px solid #34a853;
}

.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-done i {
  font-size: 16px;
  font-weight: 700;
}

.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-progress {
  background: #f3e8ff;
  color: #7e22ce;
  border: 1px solid #a855f7;
}

.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-progress i {
  font-size: 15px;
}

.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-pending {
  background: #f3f4f6;
  color: #9ca3af;
  border: 1px solid #e5e7eb;
}

.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-pending i {
  font-size: 14px;
  opacity: 0.9;
}

.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-current-approved {
  background: #e6f4ea;
  color: #1e8e3e;
  border: 2px solid #34a853;
}

.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-current-quoted {
  background: #fff7ed;
  color: #ea580c;
  border: 2px solid #fb923c;
}

.pq-workflow-timeline--v2 .pq-wf-body {
  min-width: 0;
  flex: 1 1;
}

.pq-workflow-timeline--v2 .pq-wf-title {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  line-height: 1.35;
  margin-top: 0;
}

.pq-workflow-timeline--v2 .pq-wf-title--muted {
  color: black;
  font-weight: 600;
}

.pq-workflow-timeline--v2 .pq-wf-sub {
  font-size: 13px;
  margin-top: 3px;
  line-height: 1.35;
}

/* Status caption under title: neutral grey (stage color is on the dot + line only) */
.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-completed {
  color: #16a34a !important;
  font-weight: 400;
  letter-spacing: 0.05rem;
}

.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-progress {
  color: black !important;
  font-weight: 400;
  padding-top: 3px;
}

.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-current-green {
  color: #16a34a !important;
  font-weight: 400;
}

.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-current-orange {
  color: #ea580c !important;
  font-weight: 500;
}

.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-pending {
  color: black !important;
  font-weight: 500;
}

.pq-workflow-timeline--v2 .pq-wf-extra {
  font-size: 12px;
  color: black !important;
  margin-top: 6px;
  line-height: 1.4;
}

.pq-workflow-timeline--v2 .pq-wf-link-row {
  font-size: 12px;
  color: black !important;
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.pq-workflow-timeline--v2 .pq-linked-quote-btn {
  border: 0;
  background: none;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: #2563eb !important;
  cursor: pointer;
  text-decoration: none;
  text-underline-offset: 2px;
}

.pq-workflow-timeline--v2 .pq-linked-quote-btn:hover {
  color: #1d4ed8 !important;
}

/* Reopen project confirmation (Actions → Reopen) */
.pq-reopen-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(2px);
}

.pq-reopen-modal {
  width: 100%;
  max-width: 480px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);
  border: 1px solid #e5e7eb;
  padding: 24px 24px 20px;
}

.pq-reopen-modal__header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 14px;
}

.pq-reopen-modal__icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: linear-gradient(145deg, #fb923c 0%, #ea580c 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  line-height: 1;
}

.pq-reopen-modal__title {
  margin: 4px 0 0;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.25;
}

.pq-reopen-modal__body {
  margin: 0 0 22px;
  font-size: 14px;
  line-height: 1.55;
  color: #475569;
}

.pq-reopen-modal__footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.pq-reopen-modal__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 18px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.pq-reopen-modal__btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.pq-reopen-modal__btn--secondary {
  background: #ffffff;
  border-color: #d1d5db;
  color: #111827;
}

.pq-reopen-modal__btn--secondary:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #9ca3af;
}

.pq-reopen-modal__btn--primary {
  background: linear-gradient(145deg, #fb923c 0%, #ea580c 100%);
  border-color: #ea580c;
  color: #ffffff;
}

.pq-reopen-modal__btn--primary:hover:not(:disabled) {
  filter: brightness(1.03);
}

.pq-reopen-modal__btn--primary i {
  font-size: 18px;
}

/* Signage project view — attachment actions + pending proof groups (conversation / shared files) */
.pq-attachment-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.pq-attachment-view.pq-attachment-download {
  color: #2563eb;
  border-color: #bfdbfe;
  background: #eff6ff;
}

.pq-attachment-view.pq-attachment-download:hover {
  background: #dbeafe;
  border-color: #93c5fd;
}

.pq-proof-group-head--proof-pending {
  justify-content: flex-start;
}

.pq-proof-group-head-proof-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.pq-proof-group-head-count {
  font-weight: 700;
  color: #4338ca;
}

/* Quick Actions — SELECT PROOF VERSION (premium: card lift, blue selection block, white pills) */
.pq-side-box.pq-proof-version-card {
  padding: 0;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid #e4e9f0;
  background: #fff;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.04),
    0 4px 16px rgba(15, 23, 42, 0.06);
}

.pq-proof-version-card-head {
  font-size: 0.8rem;
  font-weight: 700;
  color: #3730a3;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 18px;
  margin: 0;
  border-bottom: 1px solid #e8ecf1;
  background: linear-gradient(to right, #eef2ff, #f5f8ff);
}

.pq-proof-version-card-head i {
  font-size: 17px;
  color: #3730a3;
}

.pq-proof-version-empty {
  padding: 20px 18px 16px;
  margin: 0;
  line-height: 1.5;
}

.pq-proof-version-list {
  list-style: none;
  margin: 0;
  padding: 14px 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pq-proof-version-item {
  margin: 0;
}

.pq-proof-version-label {
  display: grid;
  grid-template-columns: 30px 1fr;
  gap: 16px;
  align-items: start;
  padding: 18px 16px 20px;
  margin: 0;
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid #eceff4;
  background: #fff;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease;
}

.pq-proof-version-label:hover:not(.is-approved):not(.is-selected) {
  border-color: #dde3eb;
  background: #fbfcfe;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}

.pq-proof-version-label.is-selected {
  background: #f0f7ff;
  border-color: #b6d2f7;
  box-shadow:
    0 0 0 1px rgba(37, 99, 235, 0.12),
    0 4px 14px rgba(37, 99, 235, 0.08);
}

.pq-proof-version-label.is-approved {
  cursor: default;
  border-color: #eceff4;
  background: #fff;
  opacity: 1;
}

.pq-proof-version-label.is-approved:hover {
  border-color: #eceff4;
  background: #fff;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);
}

.pq-proof-version-radio-cell {
  position: relative;
  width: 30px;
  height: 26px;
  flex-shrink: 0;
}

.pq-proof-version-radio-input {
  position: absolute;
  left: 0;
  top: 2px;
  width: 24px;
  height: 24px;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.pq-proof-version-label.is-approved .pq-proof-version-radio-input {
  cursor: not-allowed;
}

.pq-proof-version-radio-faux {
  position: relative;
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #c5cdd8;
  background: #fff;
  pointer-events: none;
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease;
  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.9);
}

.pq-proof-version-label.is-selected .pq-proof-version-radio-faux {
  border-color: #2563eb;
  box-shadow:
    inset 0 0 0 5px #fff,
    inset 0 0 0 14px #2563eb,
    0 0 0 3px rgba(37, 99, 235, 0.15);
}

.pq-proof-version-label.is-approved .pq-proof-version-radio-faux {
  border-color: #16a34a;
  background: #fff;
  box-shadow: none;
}

.pq-proof-version-label.is-approved .pq-proof-version-radio-faux::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -56%);
  color: #16a34a;
  font-size: 15px;
  font-weight: 800;
  line-height: 1;
}

.pq-proof-version-radio-input:focus-visible+.pq-proof-version-radio-faux {
  outline: 2px solid #3b82f6;
  outline-offset: 3px;
}

.pq-proof-version-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.pq-proof-version-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  width: 100%;
}

.pq-proof-version-title {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #0c1222;
  letter-spacing: -0.02em;
  line-height: 1.35;
}

.pq-proof-version-label.is-selected .pq-proof-version-title {
  color: #0f172a;
}

.pq-proof-version-file-count {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  padding-top: 1px;
  letter-spacing: -0.01em;
}

.pq-proof-version-approved-tag {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border-radius: 0;
  background: transparent;
  border: 0;
  color: #16a34a;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
}

.pq-proof-version-approved-tag-btn {
  gap: 5px;
  height: 32px;
  padding: 0 14px;
  border-radius: 10px;
  border: 0;
  background: #16a34a;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
}

.pq-proof-version-approved-tag-btn:hover:not(:disabled) {
  background: #15803d;
}

.pq-proof-version-approved-tag-btn i {
  font-size: 15px;
}

.pq-proof-version-approved-tag-btn:disabled {
  cursor: not-allowed;
  opacity: 0.75;
}

.pq-proof-version-chips {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.pq-proof-version-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  padding: 10px 14px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  letter-spacing: -0.01em;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;
}

.pq-proof-version-label.is-selected .pq-proof-version-chip {
  border-color: #c5daf7;
  background: #fff;
  box-shadow:
    0 1px 2px rgba(37, 99, 235, 0.06),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.pq-proof-version-chip i {
  font-size: 16px;
  color: #64748b;
  flex-shrink: 0;
  opacity: 0.92;
}

.pq-proof-version-chip-name {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.4;
}

.pq-proof-version-card .pq-proof-version-submit.pq-full-btn {
  width: calc(100% - 32px);
  margin: 8px 16px 18px;
  height: 48px;
  border-radius: 12px;
  background: #fff;
  border: 1.5px solid #3b82f6;
  color: #1d4ed8;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.02em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.12);
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    color 0.15s ease;
}

.pq-proof-version-card .pq-proof-version-submit.pq-full-btn:hover:not(:disabled) {
  background: #eff6ff;
  border-color: #2563eb;
  color: #1e40af;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.18);
}

.pq-proof-version-card .pq-proof-version-submit.pq-full-btn i {
  font-size: 20px;
  color: #2563eb;
}
.pq-proof-version-card .pq-proof-version-submit.pq-full-btn:hover i {
  font-size: 20px;
  color: white;
}

.pq-proof-version-card .pq-proof-version-submit.pq-full-btn.pq-btn-disabled {
  border-color: #cbd5e1;
  color: #94a3b8;
  box-shadow: none;
}

.pq-proof-version-card .pq-proof-version-submit.pq-full-btn.pq-btn-disabled i {
  color: #94a3b8;
}

.pq-side-title--quick-actions::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2563eb;
  flex-shrink: 0;
  margin-right: 2px;
}

/* Composer outer frame (replaces inline styles; margins scale on narrow viewports) */
.pq-composer-border-wrap {
  box-sizing: border-box;
  margin: 0 clamp(0px, 2vw, 10px) 20px;
  border: 1px solid #e5e7eb;
  border-radius: 15px;
  overflow: hidden;
}

/* ---- Signage project view — mobile / narrow viewport (must stay last to win cascade) ---- */
@media (max-width: 768px) {
  .pq-page-subtitle {
    margin-left: 0 !important;
  }

  .pq-view-title-row {
    align-items: flex-start;
  }

  .pq-view-head .pq-actions-wrap {
    width: 100%;
  }

  .pq-view-head .pq-ref-actions {
    width: 100%;
    min-height: 44px;
    justify-content: center;
  }

  .pq-agent-grid-top {
    grid-template-columns: 1fr !important;
    gap: 16px;
  }

  .pq-agent-item {
    padding: 14px 12px;
  }

  .pq-additional-details-row {
    justify-content: center !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .pq-additional-btn {
    width: min(100%, 360px) !important;
    min-height: 44px;
    margin-left: auto !important;
    margin-right: auto !important;
    padding-left: 20px;
    padding-right: 20px;
  }

  .pq-expand-details .row.justify-content-end {
    justify-content: center !important;
    margin-right: 0 !important;
  }

  .pq-agent-address-section.px-4 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .pq-agent-address-row--city-state-zip {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .pq-meta-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .pq-k {
    font-size: 0.9375rem;
    line-height: 1.35;
  }

  .pq-v {
    font-size: 1rem;
    line-height: 1.45;
    word-break: break-word;
  }

  .pq-convo-bubble-wrap {
    margin-left: 0 !important;
    width: 100% !important;
    max-width: 100%;
  }

  .pq-convo-item .pq-attachment {
    width: 100%;
  }

  /* Keep Conversation + Shared Files on one row; scroll if needed; Mute tucks on the right. */
  .pq-tabs-with-right {
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 0;
    padding: 0 12px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  .pq-tab {
    flex: 0 0 auto;
    justify-content: center;
    min-height: 48px;
    padding: 0 12px;
    font-size: 13px;
  }

  .pq-mute-btn {
    flex: 0 0 auto;
    margin-left: auto;
    min-height: 44px;
    padding: 0 10px;
    align-self: center;
  }

  .pq-msg-proof-approved-head {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .pq-msg-proof-approved-head-left {
    flex-wrap: wrap;
    gap: 8px;
  }

  .pq-msg-proof-by {
    white-space: normal;
    align-self: center;
    text-align: center;
  }

  .pq-msg-proof-by--stack {
    align-items: center;
    align-self: center;
    text-align: center;
  }

  .pq-msg-proof-by-line {
    text-align: center;
  }

  .pq-msg-proof-row--rich .pq-msg-proof-row-top {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  /* Filename must not shrink in flex (was breaking one character per line). */
  .pq-msg-proof-approved,
  .pq-msg-proof-rows,
  .pq-msg-proof-row--rich,
  .pq-msg-proof-row--rich .pq-msg-proof-row-inner {
    min-width: 0;
    max-width: 100%;
  }

  .pq-msg-proof-row--rich .pq-msg-proof-row-main {
    flex-wrap: wrap;
    width: 100%;
    align-content: flex-start;
  }

  .pq-msg-proof-row--rich .pq-msg-proof-row-main>.pq-msg-proof-row-name {
    flex: 1 1 100%;
    min-width: 0;
    max-width: 100%;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  .pq-msg-proof-row-actions {
    align-self: flex-end;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
  }

  .pq-msg-proof-row-view,
  .pq-msg-proof-row-download {
    width: 44px;
    height: 44px;
  }

  .pq-msg-proof-row-sub--enduser {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .pq-msg-proof-row-sub--enduser .pq-msg-proof-row-sub-ico {
    margin-top: 0;
  }

  .pq-msg-proof-row-sub-meta {
    margin-left: 0;
  }

  .pq-msg-proof-row-sub:not(.pq-msg-proof-row-sub--enduser) {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .pq-msg-proof-row-sub:not(.pq-msg-proof-row-sub--enduser) .pq-msg-proof-row-sub-dot {
    display: none;
  }

  .pq-file-actions {
    gap: 12px;
  }

  .pq-file-actions .pq-file-action-btn {
    min-width: 44px;
    min-height: 44px;
    padding: 8px;
    box-sizing: border-box;
  }

  .pq-convo-list,
  .pq-shared-files {
    max-height: min(420px, 50vh);
    padding-left: 14px;
    padding-right: 14px;
  }

  .pq-composer-border-wrap {
    margin-left: 0;
    margin-right: 0;
    border-radius: 12px;
  }

  .pq-workflow-timeline--v2 .pq-wf-title {
    font-size: 15px;
  }

  .pq-workflow-timeline--v2 .pq-wf-sub {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .pq-back-link {
    min-height: 44px;
    padding: 6px 4px 6px 0;
    align-items: center;
  }

  .pq-status-pill {
    min-height: 32px;
    padding: 4px 12px;
  }
}

.w-60 {
  width: 60%;
}

@media (max-width :769px) {
  .w-60 {
    width: 100%;
  }
}

/* Approved proof — internal order summary (below order details) */
.pq-proof-order-summary {
  border-top: 1px solid #e5e7eb;
  background: #fff;
  font-family: "Roboto", sans-serif;
}

.pq-proof-order-summary-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 16px 8px;
}

.pq-proof-order-summary-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.pq-proof-order-summary-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
  display: block;
}

.pq-proof-order-summary-hint {
  font-size: 11px;
  color: #9ca3af;
}

.pq-proof-order-summary-view-wrap,
.pq-proof-order-summary-edit-wrap {
  padding: 0 16px 14px;
}

.pq-proof-order-summary-view {
  position: relative;
  background: #fafafa;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
}

.pq-proof-order-summary-text {
  margin: 0;
  padding-right: 28px;
  font-size: 14px;
  color: #111827;
  line-height: 1.6;
  white-space: pre-wrap;
}

.pq-proof-order-summary-edit-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  border: none;
  background: transparent;
  color: #9ca3af;
  border-radius: 6px;
  padding: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pq-proof-order-summary-edit-btn:hover {
  color: #374151;
  background: #f3f4f6;
}

.pq-proof-order-summary-textarea {
  width: 100%;
  min-height: 90px;
  padding: 12px 14px;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #111827;
  line-height: 1.6;
  resize: vertical;
  background: #fff;
  box-sizing: border-box;
}

.pq-proof-order-summary-textarea:focus {
  outline: none;
  border-color: #6b7280;
}

.pq-proof-order-summary-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.pq-proof-order-summary-foot-hint {
  font-size: 12px;
  color: #9ca3af;
}

.pq-proof-order-summary-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: auto;
}

.pq-proof-order-summary-cancel-btn {
  padding: 5px 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
}

.pq-proof-order-summary-cancel-btn:hover:not(:disabled) {
  background: #f9fafb;
}

.pq-proof-order-summary-save-btn {
  padding: 5px 14px;
  border-radius: 6px;
  border: none;
  background: #2563eb;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
}
.pq-proof-order-summary-save-btn:hover {
  background: #1d4ed8;
}

.pq-proof-order-summary-save-btn:hover:not(:disabled) {
  background: #1d4ed8;
}

.pq-proof-order-summary-save-btn:disabled,
.pq-proof-order-summary-cancel-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/signage/projectandquote-view.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,oDAAoD;AACtD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;;;;;;;GAQG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;;AAGA,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;GAGG;;AAEH;;;;GAIG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB;;wBAEsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;;;;qBAImB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B;;;;yBAIuB;AACzB;;AAEA;;;;;;;GAOG;;AAEH;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB;;;;;mBAKiB;EACjB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;;;;qBAImB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,2BAA2B;EAC3B;;;;yBAIuB;AACzB;;AAEA;EACE;;;;;;2BAMyB;;EAEzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE;;;sBAGoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;EAEE,SAAS;AACX;;AAEA,gGAAgG;AAChG;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,qGAAqG;;AAErG;EACE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;;;;;;;EAQE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;GAIG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;;;;IAIE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;;;;;GAOG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;EACf;;;oBAGkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,4BAA4B;EAC5B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,iFAAiF;AACjF;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qEAAqE;AACrE;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;;;AAIA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,wEAAwE;AACxE;EACE,UAAU;EACV;;;;;iDAK+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;;AAGA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;IACX,8BAA8B;EAChC;;;;EAIA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,OAAO;IACP,qCAAqC;IACrC,gDAAgD;EAClD;AACF;;AAEA,qFAAqF;AACrF;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA,+FAA+F;AAC/F;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,qFAAqF;AACrF;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,oDAAoD;EACpD,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,6DAA6D;EAC7D,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA,mGAAmG;AACnG;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iGAAiG;AACjG;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB;;qCAEmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,0CAA0C;EAC1C;;;yBAGuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;;sCAEoC;AACtC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB;;yBAEuB;EACvB,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB;;;qCAGmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,4CAA4C;EAC5C;;;yBAGuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB;;0CAEwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,6CAA6C;EAC7C;;;;oBAIkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA,qFAAqF;AACrF;EACE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8FAA8F;AAC9F;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;IAClC,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA,4FAA4F;EAC5F;IACE,iBAAiB;IACjB,oBAAoB;IACpB,MAAM;IACN,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA,4EAA4E;EAC5E;;;;IAIE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;;IAEE,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,kEAAkE;AAClE;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".project-quote-page.pq-page-shell {\n  /* padding: 20px; */\n  /* background: #f8fafc; */\n  min-height: 100vh;\n  font-family: \"Roboto\", sans-serif;\n  color: #0f172a;\n}\n\n.pq-view-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n  padding: 22px 24px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n}\n\n.pq-view-title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.pq-back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: transparent;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 0;\n}\n\n.pq-back-link:hover {\n  color: #1d4ed8;\n}\n\n.pq-ref-divider {\n  width: 1px;\n  height: 20px;\n  background: #d1d5db;\n}\n\n.pq-view-title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.pq-status-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 30px;\n  padding: 0 12px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0369a1;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.pq-page-subtitle {\n  margin: 8px 0 0;\n  color: #64748b;\n  font-size: 0.875rem;\n  color: #495363 !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  margin-left: 74px;\n}\n\n.pq-back-link {\n  box-shadow: none !important;\n}\n\n\n.pq-page-subtitle strong {\n  color: #0f172a;\n}\n\n.pq-actions-wrap {\n  position: relative;\n}\n\n.pq-btn {\n  border: 1px solid transparent;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #fff;\n}\n\n.pq-btn-outline {\n  border-color: #d1d5db;\n  color: #334155;\n  background: #fff;\n}\n\n.pq-btn-outline:hover {\n  background: #f8fafc;\n}\n\n.pq-btn-primary {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.pq-btn-primary:hover {\n  background: #1d4ed8;\n  border-color: #1d4ed8;\n}\n\n.pq-ref-actions {\n  min-width: 128px;\n  height: 42px;\n}\n\n.pq-actions-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 180px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n  z-index: 20;\n}\n\n.pq-actions-menu button {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  padding: 12px 14px;\n  text-align: left;\n  color: #334155;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pq-actions-menu button:hover {\n  background: #f8fafc;\n}\n\n.pq-layout-two-col {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 360px;\n  gap: 18px;\n  align-items: start;\n}\n\n.pq-main-col {\n  min-width: 0;\n}\n\n.pq-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  overflow: hidden;\n}\n\n.pq-section-card {\n  margin-bottom: 18px;\n}\n\n.pq-card-head {\n  padding: 15px 18px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.pq-card-head-with-action {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.pq-card-body {\n  padding: 20px;\n}\n\n.pq-ref-card-head-blue {\n  /* background: linear-gradient(to right, #eff6ff, #ffffff); */\n  background: linear-gradient(to right, #eff6ff, #fff);\n}\n\n.pq-ref-card-head-indigo {\n  background: linear-gradient(to right, #eef2ff, #ffffff);\n}\n\n.pq-ref-head-title {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #1e3a8a;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.pq-agent-grid-top {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n}\n\n.pq-agent-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  /* border: 1px solid #e5e7eb; */\n  border-radius: 12px;\n  /* background: #f8fafc; */\n  padding: 14px;\n}\n\n.pq-agent-item-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.pq-agent-item-icon.user {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.pq-agent-item-icon.email {\n  background: #e0e7ff;\n  color: #4f46e5;\n}\n\n.pq-agent-item-icon.phone {\n  background: #cffafe;\n  color: #0891b2;\n}\n\n.pq-agent-item-icon.brokerage {\n  background: #f3e8ff;\n  color: #7c3aed;\n}\n\n/* .pq-k {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  margin-bottom: 4px;\n} */\n\n/* .pq-v {\n  font-size: 14px;\n  font-weight: 500;\n  color: #0f172a;\n  line-height: 1.5;\n} */\n\n.pq-block-value {\n  margin-top: 4px;\n}\n\n.pq-additional-btn {\n  margin-top: 16px;\n  width: 25%;\n  height: 38px;\n  padding: 0 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  box-sizing: border-box;\n}\n\n.pq-expand-details {\n  /* margin-top: 4px; */\n}\n\n.pq-split-line {\n  border-top: 1px solid #e5e7eb;\n  margin: 18px 0;\n}\n\n.pq-space-top {\n  margin-top: 20px;\n}\n\n.pq-agent-grid-bottom,\n.pq-agent-address-grid,\n.pq-meta-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n}\n\n/* .pq-address-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 14px;\n} */\n\n.pq-conversation-card-body {\n  padding: 0;\n}\n\n.pq-tabs-with-right {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  padding: 0 18px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n.pq-tab {\n  height: 52px;\n  padding: 0 16px;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  background: transparent;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: -1px;\n  cursor: pointer;\n  border-radius: 0;\n}\n\n.pq-tab:hover {\n  background: none;\n}\n\n.pq-tab i {\n  font-size: 18px;\n  color: #000000;\n}\n\n.pq-tab.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n  font-weight: 700;\n}\n\n.pq-tab:not(.active):hover {\n  border-bottom-color: #9ca3af;\n}\n\n.pq-tab.active i {\n  color: #2563eb;\n}\n\n.pq-tab-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  padding: 0 8px;\n  margin-left: 6px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.pq-muted {\n  color: #94a3b8;\n}\n\n.pq-mute-btn {\n  margin-left: auto;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: #000000;\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.pq-mute-btn i {\n  color: #94a3b8;\n}\n\n.pq-mute-btn:hover {\n  background: #f8fafc;\n  border-color: #cbd5e1;\n}\n\n.pq-mute-btn.pq-mute-btn-active {\n  border-color: #fdba74;\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.pq-mute-btn.pq-mute-btn-active i {\n  color: #ea580c;\n}\n\n.pq-convo-list,\n.pq-shared-files {\n  padding: 18px;\n}\n\n/* Per-message white cards removed — see \"conversation area final override\" */\n\n.pq-convo-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 12px;\n}\n\n.pq-convo-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pq-convo-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-convo-avatar.agent {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n.pq-convo-avatar.designer {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.pq-convo-user-meta strong {\n  display: inline;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.25;\n}\n\n.pq-convo-role {\n  display: inline-flex;\n  align-items: center;\n  height: 26px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.pq-convo-time {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.pq-convo-top-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pq-reply-btn {\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.pq-reply-inline {\n  border-left: 3px solid #93c5fd;\n  background: #eff6ff;\n  border-radius: 8px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pq-reply-inline strong {\n  font-size: 12px;\n  color: #1d4ed8;\n}\n\n.pq-reply-inline span {\n  font-size: 13px;\n  color: #475569;\n}\n\n.pq-convo-text {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.65;\n  color: #334155;\n  white-space: pre-wrap;\n}\n\n.pq-attachments {\n  margin-top: 14px;\n  display: grid;\n  gap: 10px;\n}\n\n.pq-attachment {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 12px;\n  background: #f8fafc;\n}\n\n.pq-attachment-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.pq-attachment-fileicon {\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: #eef2ff;\n  color: #4f46e5;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-attachment-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.pq-attachment-download {\n  width: 34px;\n  height: 34px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n}\n\n.pq-convo-input-wrap {\n  /* border-top: 1px solid #e5e7eb; */\n  padding: 18px;\n  background: #fff;\n}\n\n.pq-replying-bar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 12px;\n  padding: 12px 14px;\n  margin-bottom: 14px;\n}\n\n.pq-replying-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.pq-replying-meta strong {\n  font-size: 13px;\n  color: #1d4ed8;\n}\n\n.pq-replying-meta span {\n  font-size: 13px;\n  color: #475569;\n}\n\n.pq-replying-cancel {\n  border: 0;\n  background: transparent;\n  color: #64748b;\n  font-size: 18px;\n}\n\n.pq-msg-input {\n  width: 100%;\n  min-height: 110px;\n  resize: vertical;\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  padding: 14px 16px;\n  font-size: 14px;\n  color: #0f172a;\n  outline: none;\n}\n\n.pq-msg-input::placeholder {\n  color: #94a3b8;\n}\n\n.pq-msg-input:focus {\n  border-color: #93c5fd;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.08);\n}\n\n.pq-attached-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.pq-attached-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid #dbeafe;\n  background: #eff6ff;\n  color: #1e3a8a;\n  border-radius: 999px;\n  padding: 8px 10px;\n  font-size: 12px;\n}\n\n.pq-attached-pill-name {\n  max-width: 180px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pq-attached-pill-size {\n  color: #64748b;\n}\n\n.pq-attached-pill-remove {\n  width: 20px;\n  height: 20px;\n  border: 0;\n  border-radius: 999px;\n  background: #dbeafe;\n  color: #1d4ed8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-msg-actions--composer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  /* margin-top: 16px; */\n}\n\n.pq-msg-actions-left {\n  display: flex;\n  align-items: center;\n}\n\n.pq-btn-sm {\n  height: 38px;\n  padding: 0 14px;\n}\n\n.pq-attach-label {\n  margin: 0;\n}\n\n.pq-msg-toolbar-divider {\n  width: 1px;\n  align-self: stretch;\n  background: #e5e7eb;\n}\n\n.pq-design-proof-block {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pq-design-proof-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.pq-design-proof-toggles {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pq-toggle-yesno {\n  height: 34px;\n  padding: 0 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 999px;\n  background: #fff;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.pq-toggle-yesno.active {\n  background: #2563eb;\n  border-color: #2563eb;\n  color: #fff;\n}\n\n.pq-msg-toolbar-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n}\n\n/* \n.pq-emoji-inline-btn {\n  width: 36px;\n  height: 36px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: #475569;\n} */\n\n.pq-attached-count-text {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.pq-send-btn {\n  height: 40px;\n  padding: 0 16px;\n  margin-left: 0;\n}\n\n.pq-proof-group {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.pq-proof-group+.pq-proof-group {\n  margin-top: 14px;\n}\n\n.pq-proof-group-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  background: #eef2ff;\n  color: #4338ca;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.pq-proof-group-head.plain {\n  background: #f8fafc;\n  color: #475569;\n}\n\n.pq-proof-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #c7d2fe;\n  color: #3730a3;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.pq-file-row {\n  display: grid;\n  grid-template-columns: 52px 1fr auto;\n  gap: 14px;\n  align-items: center;\n  padding: 14px;\n  border-top: 1px solid #eef2f7;\n}\n\n.pq-file-type {\n  min-width: 46px;\n  height: 30px;\n  border-radius: 8px;\n  background: #fee2e2;\n  color: #991b1b;\n  font-size: 11px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-file-type.png,\n.pq-file-type.jpg,\n.pq-file-type.jpeg {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.pq-file-meta {\n  min-width: 0;\n}\n\n.pq-file-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.pq-file-sub {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  font-size: 0.875rem;\n  color: #495363 !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  margin-top: 2px;\n}\n\n.pq-file-sub-name {\n  font-weight: 600;\n  color: #334155;\n}\n\n.pq-file-sub-role {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.pq-file-sub-time {\n  color: #64748b;\n  font-size: 12px;\n}\n\n.pq-file-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #94a3b8;\n}\n\n.pq-file-actions a,\n.pq-file-actions .pq-file-action-btn,\n.pq-file-actions i {\n  font-size: 18px;\n  color: #64748b;\n}\n\n.pq-file-actions .pq-file-action-btn {\n  border: none;\n  background: transparent;\n  padding: 0;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.pq-sticky-side {\n  position: sticky;\n  top: 18px;\n  overflow: visible;\n}\n\n.pq-sidebar-body {\n  padding: 18px;\n}\n\n.pq-workflow-timeline {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.pq-workflow-item {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  padding-bottom: 20px;\n}\n\n.pq-workflow-item:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  left: 14px;\n  top: 32px;\n  bottom: 0;\n  width: 2px;\n  background: #e5e7eb;\n}\n\n.pq-workflow-dot {\n  position: relative;\n  z-index: 1;\n  width: 30px;\n  height: 30px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.pq-workflow-dot.done {\n  background: #dcfce7;\n  color: #16a34a;\n}\n\n.pq-workflow-dot.progress {\n  background: #ede9fe;\n  color: #7c3aed;\n}\n\n.pq-workflow-dot.pending {\n  background: #f3f4f6;\n  color: black;\n}\n\n.pq-wf-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-wf-sub {\n  font-size: 0.875rem;\n  color: #495363 !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  margin-top: 2px;\n}\n\n.pq-wf-sub.done {\n  color: #16a34a;\n}\n\n.pq-wf-sub.progress {\n  color: #7c3aed;\n}\n\n.pq-wf-extra {\n  margin-top: 4px;\n  font-size: 0.875rem;\n  color: #495363 !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n}\n\n.pq-side-section {\n  margin-top: 18px;\n  padding-top: 18px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.pq-side-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #166534;\n}\n\n.pq-side-box {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  padding: 14px;\n  margin-bottom: 14px;\n}\n\n.pq-side-box-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  font-size: 12px;\n  font-weight: 800;\n  color: #334155;\n  letter-spacing: 0.03em;\n}\n\n.pq-radio-row {\n  display: grid;\n  grid-template-columns: 18px 1fr auto;\n  gap: 12px;\n  align-items: start;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px;\n  background: #fff;\n  margin-bottom: 10px;\n}\n\n.pq-radio-row.selected {\n  border-color: #93c5fd;\n  background: #eff6ff;\n}\n\n.pq-radio-row input {\n  margin-top: 4px;\n}\n\n.pq-proof-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pq-proof-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.pq-proof-file-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: fit-content;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n  font-size: 12px;\n  color: #4b5563;\n}\n\n.pq-full-btn {\n  width: 100%;\n  margin-top: 4px;\n  height: 42px;\n}\n\n.pq-btn-disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.pq-required {\n  color: #ef4444;\n}\n\n.pq-order-option {\n  display: grid;\n  grid-template-columns: 18px 1fr;\n  gap: 12px;\n  align-items: center;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px;\n  background: #fff;\n  margin-bottom: 10px;\n}\n\n.pq-order-option input {\n  margin: 0;\n}\n\n.pq-order-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pq-order-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: #f8fafc;\n  border: 1px solid #e5e7eb;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.pq-order-row strong {\n  display: block;\n  font-size: 14px;\n  color: #111827;\n  margin-bottom: 2px;\n}\n\n.pq-order-row small {\n  font-size: 0.875rem;\n  color: #495363 !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n}\n\n.pq-cancel-btn {\n  color: #dc2626;\n  border-color: #fecaca;\n  background: #fff5f5;\n}\n\n.pq-cancel-btn:hover {\n  background: #fef2f2;\n}\n\n@media (max-width: 1200px) {\n  .pq-layout-two-col {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-sticky-side {\n    position: static;\n  }\n}\n\n@media (max-width: 768px) {\n  .project-quote-page.pq-page-shell {\n    padding: 14px;\n  }\n\n  .pq-view-head {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 18px;\n  }\n\n  .pq-ref-divider {\n    display: none;\n  }\n\n  .pq-agent-grid-top,\n  .pq-agent-grid-bottom,\n  .pq-agent-address-grid,\n  .pq-meta-row {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-agent-address-row--city-state-zip {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-tabs-with-right {\n    flex-wrap: wrap;\n    padding-bottom: 10px;\n  }\n\n  .pq-mute-btn {\n    margin-left: 0;\n  }\n\n  .pq-convo-top {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .pq-msg-actions--composer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pq-msg-toolbar-divider {\n    display: none;\n  }\n\n  .pq-msg-toolbar-meta {\n    margin-left: 0;\n    justify-content: space-between;\n  }\n\n  .pq-send-btn,\n  .pq-attach-label {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .pq-file-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n/* ===== Reference matching overrides ===== */\n.project-quote-page.pq-page-shell {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 0 clamp(16px, 3vw, 40px) 28px;\n  /* background: #f3f4f6; */\n}\n\n.pq-layout-two-col {\n  grid-template-columns: minmax(0, 1fr) 430px;\n  gap: 24px;\n  align-items: start;\n}\n\n.pq-view-head,\n.pq-card {\n  border-color: #d8dee8;\n  border-radius: 16px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);\n}\n\n.pq-view-head {\n  padding: 22px 28px;\n  margin-bottom: 20px;\n}\n\n.pq-view-title {\n  font-size: 24px;\n  line-height: 1.2;\n}\n\n\n.pq-card-head {\n  padding: 16px 22px;\n  background: #f3f6fc;\n  border-radius: 15px 15px 0px 0px;\n}\n\n/* .pq-ref-card-head-blue,\n.pq-ref-card-head-indigo {\n  background: #f3f6fc;\n} */\n\n/* .pq-ref-head-title {\n  color: #2f4fd2;\n  font-size: 16px;\n  font-weight: 700;\n} */\n\n.pq-ref-head-title i {\n  font-size: 18px;\n}\n\n.pq-card-body {\n  padding: 20px 22px;\n}\n\n.pq-agent-grid-top {\n  gap: 14px;\n}\n\n.pq-agent-item {\n  /* min-height: 78px; */\n  padding: 15px 18px;\n  /* background: #ffffff;\n  border-color: #d8dee8;\n  border-radius: 14px; */\n}\n\n.pq-agent-item-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 999px;\n  font-size: 20px;\n}\n\n\n.pq-agent-item-icon.user {\n  background: #dbeafe;\n  color: #2d63f6;\n}\n\n.pq-agent-item-icon.email {\n  background: #d9f0fb;\n  color: #0ea5d7;\n}\n\n.pq-agent-item-icon.phone {\n  background: #d8f3df;\n  color: #1fad5d;\n}\n\n.pq-agent-item-icon.brokerage {\n  background: #ffe9c8;\n  color: #ff7a1a;\n}\n\n.pq-k {\n  /* font-size: 0.75rem;\n    line-height: 1rem;\n  text-transform: uppercase;\n  color: #64748b;\n  font-weight: 500; */\n  margin-bottom: 4px;\n  font-size: 0.875rem;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  /* font-weight: 500 !important; */\n}\n\n.pq-v {\n  font-size: 0.875rem;\n  color: #495363 !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  /* font-size: 0.875rem;\n    line-height: 1.25rem;\n  font-weight: 500;\n  color: #111827;\n  --tw-text-opacity: 1; */\n}\n\n/* .pq-additional-btn {\n  width: 100%;\n  height: 42px;\n  margin-top: 14px;\n  border-radius: 12px;\n  border-color: #cfd7e3;\n  font-weight: 700;\n} */\n\n.pq-split-line {\n  border-top-color: #e2e8f0;\n  margin: 18px 0;\n}\n\n.pq-address-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n  /* font-size: 13px;\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #0f172a; */\n  font-size: 0.875rem;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  font-weight: 500 !important;\n}\n\n.pq-address-heading i {\n  font-size: 16px;\n  color: #475569;\n}\n\n.pq-agent-address-section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.pq-agent-address-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.pq-agent-address-field {\n  min-width: 0;\n}\n\n.pq-agent-address-row {\n  display: grid;\n  gap: 16px 24px;\n}\n\n.pq-agent-address-row--city-state-zip {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.pq-agent-address-row--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.pq-agent-address-row--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.pq-k {\n  /* font-size: 0.75rem;\n    line-height: 1rem;\n  text-transform: uppercase;\n  color: #64748b;\n  font-weight: 500; */\n  margin-bottom: 4px;\n  font-size: 0.875rem;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  /* font-weight: 500 !important; */\n}\n\n.pq-v {\n  font-size: 0.875rem;\n  color: #000000 !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  font-weight: 500 !important;\n  /* font-size: 0.875rem;\n    line-height: 1.25rem;\n  font-weight: 500;\n  color: #111827;\n  --tw-text-opacity: 1; */\n}\n\n.pq-agent-address-section .pq-k {\n  /* display: block;\n  margin-bottom: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em; */\n\n  margin-bottom: 4px;\n  font-size: 0.875rem;\n  color: #111827;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  /* font-weight: 500 !important; */\n}\n\n.pq-agent-address-section .pq-v {\n  /* font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.45; */\n  font-size: 0.875rem;\n  color: black !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n}\n\n.pq-meta-row,\n.pq-agent-address-grid {\n  gap: 20px;\n}\n\n/* Single column by default; wider breakpoints restore 2–3 columns (must not override mobile). */\n.pq-agent-grid-bottom {\n  grid-template-columns: 1fr;\n  gap: 20px;\n}\n\n@media (min-width: 640px) {\n  .pq-agent-grid-bottom {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .pq-agent-grid-bottom {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n/* Duplicate .pq-tabs / .pq-mute rules removed — defined above + \"conversation area final override\" */\n\n.pq-convo-input-wrap {\n  /* border-top: 1px solid #e2e8f0; */\n  padding: 18px;\n}\n\n.pq-msg-input {\n  min-height: 108px;\n  border-radius: 14px;\n  border-color: #cfd7e3;\n}\n\n.pq-msg-actions--composer {\n  justify-content: space-between;\n  gap: 14px;\n}\n\n.pq-btn,\n.pq-order-option,\n.pq-radio-row,\n.pq-side-box,\n.pq-msg-input,\n.pq-proof-group,\n.pq-attachment,\n.pq-file-row {\n  border-radius: 14px;\n}\n\n.pq-sticky-side {\n  position: sticky;\n  top: 16px;\n  align-self: start;\n  max-height: none;\n  overflow: visible;\n}\n\n.pq-sidebar-body {\n  padding: 18px 22px 22px;\n  max-height: none;\n  overflow: visible;\n}\n\n.pq-workflow-timeline {\n  margin-bottom: 8px;\n}\n\n.pq-workflow-item {\n  gap: 16px;\n  padding-bottom: 28px;\n}\n\n.pq-workflow-item.is-dim {\n  opacity: 1;\n}\n\n.pq-workflow-item:not(:last-child)::after {\n  left: 15px;\n  top: 32px;\n  background: #d6dce5;\n}\n\n.pq-workflow-dot {\n  width: 32px;\n  height: 32px;\n  border: 2px solid transparent;\n}\n\n.pq-workflow-dot.done {\n  background: #d7f2dc;\n  color: #1ea854;\n}\n\n.pq-workflow-dot.progress {\n  background: #efddff;\n  color: #8a4df2;\n  border-color: #c89ef7;\n}\n\n.pq-workflow-dot.pending {\n  background: #f3f4f6;\n  color: #b4bcc8;\n}\n\n.pq-workflow-dot.current-approved {\n  background: #d7f2dc;\n  color: #1ea854;\n  border-color: #9be2ab;\n}\n\n.pq-workflow-dot.current-quoted {\n  background: #ffedd8;\n  color: #f97316;\n  border-color: #f6bf8b;\n}\n\n.pq-wf-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-top: 2px;\n}\n\n/* .pq-wf-sub {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #a0a8b6;\n} */\n\n.pq-wf-sub.done {\n  color: #1ea854;\n}\n\n.pq-wf-sub.progress {\n  color: #8a4df2;\n}\n\n.pq-wf-sub.current-approved {\n  color: #1ea854;\n}\n\n.pq-wf-sub.current-quoted {\n  color: #f97316;\n}\n\n\n.pq-wf-link-row {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #718096;\n}\n\n.pq-linked-quote-btn {\n  border: 0;\n  background: transparent;\n  color: #2d63f6;\n  font-weight: 700;\n  padding: 0;\n  margin-left: 4px;\n}\n\n.pq-side-section {\n  margin-top: 10px;\n  padding-top: 20px;\n  border-top-color: #d8dee8;\n}\n\n.pq-side-title {\n  font-size: 15px;\n  font-weight: 800;\n  color: #146534;\n}\n\n.pq-side-box {\n  border-color: #d8dee8;\n  padding: 0;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.pq-side-box-title {\n  margin: 0;\n  padding: 14px 16px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.pq-side-box>.text-muted,\n.pq-side-box>.pq-btn,\n.pq-side-box>.pq-order-option,\n.pq-side-box>.pq-radio-row {\n  margin-left: 16px;\n  margin-right: 16px;\n}\n\n.pq-side-box>.text-muted {\n  margin-top: 14px;\n}\n\n.pq-radio-row,\n.pq-order-option {\n  border-color: #d8dee8;\n  min-height: 82px;\n  margin-bottom: 12px;\n}\n\n.pq-radio-row:first-of-type,\n.pq-order-option:first-of-type {\n  margin-top: 14px;\n}\n\n.pq-radio-row.selected {\n  border-color: #99c1ff;\n  background: #eff6ff;\n}\n\n.pq-radio-row.approved {\n  background: #f0fdf4;\n  border-color: #b8e7c1;\n}\n\n.pq-proof-approved-text {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: #dcfce7;\n  color: #15803d;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.pq-proof-file-chip {\n  background: #f8fafc;\n}\n\n.pq-order-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n}\n\n.pq-full-btn {\n  width: calc(100% - 32px);\n  margin: 0 16px 16px;\n  height: 46px;\n  border-radius: 12px;\n  background: #2563eb;\n  color: #fff;\n}\n\n.pq-full-btn-cancel {\n  width: calc(100% - 32px);\n  margin: 0 16px 16px;\n  height: 46px;\n  border-radius: 12px;\n}\n\n.pq-full-btn:hover {\n  background: #1d4ed8 !important;\n  color: #fff !important;\n}\n\n.pq-btn-disabled {\n  opacity: .55;\n}\n\n.pq-cancel-btn {\n  background: #fff7f7;\n  border-color: #f7b9b9;\n  color: #e3342f;\n}\n\n.pq-status-pill.inprogress {\n  background: #cffafe;\n  color: #0e7490;\n}\n\n.pq-status-pill.approved {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.pq-status-pill.quoted {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.pq-status-pill.quote-approved {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.pq-status-pill.completed {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n@media (max-width: 1200px) {\n  .pq-layout-two-col {\n    grid-template-columns: 1fr;\n  }\n\n  .pq-sticky-side {\n    position: static;\n  }\n}\n\n@media (max-width: 768px) {\n  .project-quote-page.pq-page-shell {\n    padding: 14px;\n  }\n\n  .pq-view-head {\n    padding: 18px;\n  }\n\n  .pq-view-title {\n    font-size: 20px;\n  }\n\n  .pq-card-body,\n  .pq-card-head,\n  .pq-sidebar-body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .pq-agent-item,\n  .pq-radio-row,\n  .pq-order-option {\n    min-height: auto;\n  }\n\n  .pq-side-box>.pq-btn,\n  .pq-side-box>.pq-order-option,\n  .pq-side-box>.pq-radio-row,\n  .pq-side-box>.text-muted {\n    margin-left: 12px;\n    margin-right: 12px;\n  }\n\n  .pq-full-btn {\n    width: calc(100% - 24px);\n    margin-left: 12px;\n    margin-right: 12px;\n  }\n}\n\n/* --- conversation area final override (reference UI) --- */\n.pq-conversation-card-body {\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  min-height: 0;\n}\n\n/* Tabs: clear active / inactive (overrides earlier rules) */\n.pq-tabs-with-right {\n  flex-shrink: 0;\n  padding: 0 20px;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n/* .pq-tab {\n  height: 52px;\n  padding: 0 16px;\n  margin-bottom: -1px;\n  border-bottom: 3px solid transparent;\n  color: #000000;\n  font-weight: 500;\n} */\n\n.pq-tab:not(.active):hover {\n  color: #475569;\n}\n\n.pq-tab.active {\n  color: #2563eb;\n  border-bottom-color: #2563eb;\n}\n\n.pq-tab-badge {\n  background: #f1f5f9;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n}\n\n.pq-convo-list {\n  flex: 1 1 auto;\n  min-height: 140px;\n  max-height: min(480px, 55vh);\n  padding: 16px 18px 18px;\n  background: white;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-gutter: stable;\n}\n\n.pq-shared-files {\n  flex: 1 1 auto;\n  min-height: 140px;\n  max-height: min(480px, 55vh);\n  padding: 16px 18px 18px;\n  background: #ffffff;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-gutter: stable;\n}\n\n.pq-convo-item {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0 0 6px;\n  margin: 0;\n}\n\n.pq-convo-item+.pq-convo-item {\n  padding-top: 16px;\n  /* border-top: 1px solid #e5e7eb; */\n}\n\n.pq-convo-top {\n  margin-bottom: 10px;\n  align-items: center;\n}\n\n.pq-convo-user {\n  align-items: center;\n  min-width: 0;\n}\n\n.pq-convo-user-meta {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.pq-convo-user-meta strong {\n  display: inline;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.25;\n}\n\n.pq-convo-role {\n  display: inline-flex;\n  align-items: center;\n  height: 26px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #f3f4f6;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.pq-convo-time {\n  font-size: 12px;\n  color: #000000;\n  white-space: nowrap;\n}\n\n/* Reply: visible next to timestamp (was hidden for an older reference mock) */\n.pq-reply-btn {\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #fff;\n  color: #2563eb;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  flex-shrink: 0;\n  cursor: pointer;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    color 0.15s ease;\n}\n\n.pq-reply-btn:hover {\n  background: #eff6ff;\n  border-color: #93c5fd;\n  color: #1d4ed8;\n}\n\n.pq-reply-btn:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n.pq-reply-btn i {\n  font-size: 16px;\n  line-height: 1;\n}\n\n@media (max-width: 480px) {\n  .pq-reply-btn .pq-reply-btn-text {\n    display: none;\n  }\n\n  .pq-reply-btn {\n    padding: 0 10px;\n    min-width: 36px;\n  }\n}\n\n.pq-convo-avatar.agent {\n  background: #eceff3;\n  color: black;\n}\n\n.pq-convo-avatar.designer {\n  background: #dbeafe;\n  color: #2563eb;\n}\n\n/* Full-width gray bubble under header row (reference) */\n.pq-convo-bubble-wrap {\n  margin-left: 43px !important;\n  width: 95%;\n  max-width: 100%;\n}\n\n.pq-convo-bubble-body {\n  border-radius: 12px;\n  background: #f3f4f6;\n  overflow: hidden;\n}\n\n.pq-convo-bubble-body--admin {\n  background: #dbeafe;\n}\n\n.pq-convo-bubble-body--agent {\n  background: #f3f4f6;\n}\n\n.pq-convo-bubble-body .pq-convo-text {\n  background: transparent;\n  border-radius: 0;\n}\n\n.pq-convo-bubble-body .pq-attachments {\n  margin-top: 0;\n  padding: 0 14px 14px;\n}\n\n/* Approved proof bundle in conversation (message.approved_by + reply_to_files) */\n.pq-msg-proof-approved {\n  margin: 14px 14px 14px;\n  /* border: 1px solid #008000; */\n  border-radius: 12px;\n  background: linear-gradient(180deg, #f0fdf4 0%, #ecfdf5 100%);\n  overflow: hidden;\n}\n\n.pq-msg-proof-approved-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 14px;\n  border-bottom: 1px solid #bbf7d0;\n  background: rgba(255, 255, 255, 0.65);\n}\n\n.pq-msg-proof-approved-head-left {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pq-msg-proof-version-pill {\n  display: inline-flex;\n  align-items: center;\n  height: 28px;\n  padding: 0 12px;\n  border-radius: 999px;\n  border: 1px solid #22c55e;\n  background: #fff;\n  color: #15803d;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.pq-msg-proof-file-count {\n  font-size: 13px;\n  font-weight: 700;\n  color: #166534;\n}\n\n.pq-msg-proof-approved-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 28px;\n  padding: 0 12px;\n  border-radius: 999px;\n  background: #367C2B;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.pq-msg-proof-approved-pill i {\n  font-size: 14px;\n  line-height: 1;\n}\n\n.pq-msg-proof-by {\n  font-size: 13px;\n  font-weight: 700;\n  color: #15803d;\n  white-space: nowrap;\n}\n\n.pq-msg-proof-by--stack {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  max-width: 100%;\n  white-space: normal;\n}\n\n.pq-msg-proof-by-line {\n  display: block;\n  line-height: 1.35;\n  text-align: right;\n}\n\n.pq-msg-proof-by-line--secondary {\n  font-weight: 600;\n  color: #166534;\n}\n\n.pq-msg-proof-rows {\n  display: flex;\n  flex-direction: column;\n}\n\n.pq-msg-proof-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-top: 1px solid #bbf7d0;\n  background: #f8fffb;\n}\n\n.pq-msg-proof-row:first-of-type {\n  border-top: none;\n}\n\n.pq-msg-proof-row-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  flex: 1;\n}\n\n.pq-msg-proof-row-icon {\n  font-size: 20px;\n  color: #22c55e;\n  flex-shrink: 0;\n}\n\n.pq-msg-proof-row-letter {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: 8px;\n  background: #dcfce7;\n  color: #166534;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.pq-msg-proof-row-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pq-msg-proof-row-download {\n  box-sizing: border-box;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #f9fafb;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  line-height: 0;\n  text-decoration: none;\n}\n\n.pq-msg-proof-row-download:hover {\n  background: #ecfdf5;\n  border-color: #86efac;\n  color: #15803d;\n}\n\n.pq-msg-proof-row-download svg,\n.pq-msg-proof-row-download i {\n  display: block;\n  font-size: 18px;\n}\n\n.pq-msg-proof-row-download--disabled {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n.pq-msg-proof-head-doc {\n  font-size: 20px;\n  color: #15803d;\n  flex-shrink: 0;\n}\n\n.pq-msg-proof-row--rich {\n  align-items: stretch;\n}\n\n.pq-msg-proof-row-inner {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.pq-msg-proof-row-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.pq-msg-proof-row-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.pq-msg-proof-row-view {\n  box-sizing: border-box;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #f9fafb;\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  line-height: 0;\n  cursor: pointer;\n}\n\n.pq-msg-proof-row-view:hover {\n  background: #eff6ff;\n  border-color: #93c5fd;\n  color: #2563eb;\n}\n\n.pq-msg-proof-row-view i {\n  font-size: 18px;\n}\n\n.pq-msg-proof-row-sub {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  padding-left: 2px;\n}\n\n.pq-msg-proof-row-sub--enduser {\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.pq-msg-proof-row-sub-ico {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.pq-msg-proof-row-sub-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1 1 auto;\n  color: #475569;\n  font-weight: 600;\n}\n\n.pq-msg-proof-row-sub-brokerage {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.pq-msg-proof-row-sub-meta {\n  margin-left: auto;\n  flex-shrink: 0;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.pq-msg-proof-row-sub i {\n  font-size: 14px;\n  color: #94a3b8;\n}\n\n.pq-msg-proof-row-sub-dot {\n  color: #cbd5e1;\n}\n\n.pq-msg-proof-file-approved-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #22c55e;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.pq-msg-proof-file-approved-pill i {\n  font-size: 13px;\n}\n\n.pq-msg-proof-row-main--shared {\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.pq-msg-proof-row-main--shared .pq-file-type {\n  flex-shrink: 0;\n}\n\n.pq-proof-group--proof-chat {\n  border: none;\n  background: transparent;\n  overflow: visible;\n}\n\n.pq-msg-proof-approved--embedded {\n  margin: 0;\n}\n\n.pq-msg-proof-approved--embedded .pq-msg-proof-approved-head {\n  border-radius: 12px 12px 0 0;\n}\n\n.pq-msg-proof-approved--embedded .pq-msg-proof-rows {\n  border-radius: 0 0 12px 12px;\n  overflow: hidden;\n}\n\n.pq-shared-file-delete {\n  color: #b91c1c;\n  border-color: #fecaca;\n  background: #fef2f2;\n}\n\n.pq-shared-file-delete:hover {\n  background: #fee2e2;\n  border-color: #fca5a5;\n  color: #991b1b;\n}\n\n/* File preview modal (signage project view — proof / shared files) */\n.pq-file-preview-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 10800;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.pq-file-preview-modal {\n  width: min(920px, 100%);\n  max-height: min(90vh, 880px);\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.pq-file-preview-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.pq-file-preview-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.pq-file-preview-title-wrap>i {\n  font-size: 22px;\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.pq-file-preview-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pq-file-preview-close {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 10px;\n  background: #f1f5f9;\n  color: #475569;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.pq-file-preview-close:hover {\n  background: #e2e8f0;\n}\n\n.pq-file-preview-body {\n  flex: 1;\n  min-height: 200px;\n  max-height: min(62vh, 640px);\n  background: #0f172a;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n}\n\n.pq-file-preview-img {\n  max-width: 100%;\n  max-height: min(58vh, 600px);\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.pq-file-preview-fallback {\n  text-align: center;\n  color: #94a3b8;\n  padding: 40px 24px;\n}\n\n.pq-file-preview-fallback i {\n  font-size: 48px;\n  display: block;\n  margin-bottom: 12px;\n  opacity: 0.85;\n}\n\n.pq-file-preview-fallback p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.pq-file-preview-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n  background: #fafafa;\n}\n\n.pq-file-preview-meta {\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.pq-file-preview-download {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 18px;\n  border: none;\n  border-radius: 10px;\n  background: #2563eb;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.pq-file-preview-download:hover {\n  background: #1d4ed8;\n}\n\n.pq-file-preview-download svg {\n  flex-shrink: 0;\n  color: inherit;\n}\n\n/* Lucide icons in file rows (match prior Remix icon sizing) */\n.pq-msg-proof-row-view .sqbtn__icon svg,\n.pq-msg-proof-row-download .sqbtn__icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.pq-file-actions .sqbtn__icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.pq-attachment-download .sqbtn__icon svg {\n  width: 18px;\n  height: 18px;\n}\n\n.pq-convo-text {\n  font-size: 0.875rem;\n  color: #495363 !important;\n  letter-spacing: -.025em;\n  font-family: Roboto, sans-serif;\n  padding: 14px 16px;\n  border: none;\n  border-radius: 12px;\n  background: #f3f4f6;\n  white-space: pre-wrap;\n}\n\n\n\n.pq-convo-item.pq-convo-item--reply-target {\n  border-radius: 12px;\n  outline: 2px solid #93c5fd;\n  outline-offset: 2px;\n  background: #f8fafc;\n}\n\n.pq-convo-item .pq-attachment {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  width: 70%;\n}\n\n.pq-convo-item .pq-attachment-content {\n  min-width: 0;\n}\n\n.pq-convo-item .pq-attachment-topline {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.pq-convo-item .pq-attachment-proof-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #e9d5ff;\n  color: #6b21a8;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.pq-convo-item a.pq-attachment-download {\n  text-decoration: none;\n  color: inherit;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-convo-item .pq-attachment-download--disabled {\n  opacity: 0.45;\n  pointer-events: none;\n}\n\n/* Composer card: segmented sections + toolbar row (reference image 2) */\n.pq-convo-input-wrap {\n  padding: 0;\n  /* flex-shrink: 0;\n  margin: 0 18px 18px;\n  border: 1px solid #e5e7eb;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06); */\n  overflow: hidden;\n}\n\n.pq-convo-input-wrap::before {\n  display: none;\n}\n\n.pq-composer-section--reply {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #fafafa;\n}\n\n.pq-composer-section--text {\n  padding: 16px 18px;\n  /* border-bottom: 1px solid #e5e7eb; */\n}\n\n.pq-composer-section--attachments {\n  padding: 12px 18px 14px;\n  border-top: 1px solid #e5e7eb;\n  /* background: #fafafa; */\n}\n\n.pq-msg-input {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 112px;\n  padding: 14px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 14px;\n  line-height: 1.55;\n  resize: vertical;\n  box-shadow: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.pq-msg-input:hover {\n  border-color: #d1d5db;\n}\n\n.pq-msg-input:focus {\n  outline: none;\n  border-color: #93c5fd;\n  box-shadow: 0 0 0 3px rgba(147, 197, 253, 0.25);\n}\n\n.pq-msg-input::placeholder {\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n.pq-composer-section--attachments .pq-attached-list {\n  margin-top: 0;\n}\n\n.pq-attached-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n}\n\n.pq-attached-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 100%;\n  padding: 8px 10px 8px 12px;\n  border: 1px solid #93c5fd;\n  border-radius: 999px;\n  background: #f0f7ff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1e40af;\n}\n\n.pq-attached-pill>i.ri-file-2-line {\n  flex-shrink: 0;\n  font-size: 16px;\n  color: #3b82f6;\n}\n\n.pq-attached-pill-name {\n  color: #1d4ed8;\n  font-weight: 600;\n  max-width: min(240px, 55vw);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pq-attached-pill-size {\n  flex-shrink: 0;\n  color: #60a5fa;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.pq-attached-pill-remove {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  margin-left: 2px;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: rgba(59, 130, 246, 0.15);\n  color: #2563eb;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.pq-attached-pill-remove:hover {\n  background: rgba(59, 130, 246, 0.28);\n}\n\n.pq-msg-actions--composer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 16px 14px;\n  flex-wrap: wrap;\n}\n\n.pq-msg-toolbar-flow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px 12px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.pq-design-proof-block {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin: 0;\n}\n\n.pq-design-proof-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1f2937;\n  white-space: nowrap;\n}\n\n.pq-design-proof-toggles {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pq-toggle-yesno {\n  height: 36px;\n  padding: 0 16px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: #4b5563;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.pq-toggle-yesno:hover {\n  border-color: #9ca3af;\n  background: #f9fafb;\n}\n\n.pq-toggle-yesno.active {\n  background: #fff;\n  border-color: #2563eb;\n  color: #2563eb;\n  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.35);\n}\n\n.pq-attach-label {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  margin: 0 !important;\n  padding: 0 16px !important;\n  border: 1px solid #d1d5db !important;\n  border-radius: 12px !important;\n  background: #fff !important;\n  color: black !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  cursor: pointer;\n  box-shadow: none !important;\n}\n\n.pq-attach-label:hover {\n  background: #f9fafb !important;\n  border-color: #cbd5e1 !important;\n  color: #475569 !important;\n}\n\n.pq-msg-toolbar-divider--vertical {\n  width: 1px;\n  height: 28px;\n  background: #e2e8f0;\n  flex-shrink: 0;\n}\n\n.pq-msg-toolbar-flow .pq-attached-count-text {\n  color: black;\n  font-size: 13px;\n  font-weight: 500;\n  margin-left: 2px;\n  white-space: nowrap;\n}\n\n.pq-emoji-inline-btn {\n  width: 109px;\n  min-width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: black;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.pq-emoji-inline-btn:hover {\n  background: #f9fafb;\n  border-color: #cbd5e1;\n}\n\n.pq-emoji-inline-btn-proof {\n  width: 36px;\n  min-width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  background: #fff;\n  color: black;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.pq-emoji-inline-btn-proof:hover {\n  background: #f9fafb;\n  border-color: #cbd5e1;\n}\n\n\n.pq-convo-input-wrap .pq-send-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-shrink: 0;\n  min-width: 104px;\n  height: 44px;\n  padding: 0 18px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 700;\n  background: #1d4ed8 !important;\n  border: 1px solid #7c9fe8 !important;\n  color: #fff !important;\n  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.2);\n}\n\n.pq-convo-input-wrap .pq-send-btn:hover:not(:disabled) {\n  background: #1d4ed8 !important;\n  border-color: #7c9fe8 !important;\n}\n\n.pq-convo-input-wrap .pq-send-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pq-emoji-picker-wrap {\n  position: relative;\n}\n\n.pq-emoji-picker-pop {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 10px);\n  width: 390px;\n  max-width: min(390px, calc(100vw - 48px));\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  background: #ffffff;\n  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.14);\n  padding: 12px;\n  display: grid;\n  grid-template-columns: repeat(8, minmax(0, 1fr));\n  gap: 6px;\n  z-index: 40;\n}\n\n.pq-emoji-pick-btn {\n  height: 36px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  font-size: 23px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-emoji-pick-btn:hover {\n  background: #f1f5f9;\n}\n\n.pq-send-btn {\n  min-width: 104px;\n  height: 44px;\n  padding: 0 18px;\n  border-radius: 14px;\n  font-size: 14px;\n  font-weight: 700;\n  flex: 0 0 auto;\n}\n\n@media (max-width: 768px) {\n  .pq-convo-top-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n\n\n  .pq-msg-actions--composer {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .pq-msg-toolbar-flow {\n    width: 100%;\n  }\n\n  .pq-convo-input-wrap .pq-send-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .pq-emoji-picker-pop {\n    left: 0;\n    width: min(320px, calc(100vw - 48px));\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n}\n\n/* ---- Project Workflow v2 (status-aware stepper, SignageViewprojectandquote) ---- */\n.pq-workflow-timeline--v2 {\n  position: relative;\n}\n\n.pq-workflow-timeline--v2::before {\n  display: none !important;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-item {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  padding-bottom: 20px;\n  align-items: flex-start;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-item:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  left: 14px;\n  top: 39px;\n  bottom: -10px;\n  width: 2px;\n  background: #e5e7eb;\n  z-index: 0;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-item.pq-wf-connector-green:not(:last-child)::after {\n  background: #16a34a;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-item.pq-wf-connector-gray:not(:last-child)::after {\n  background: #e5e7eb;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-dot {\n  position: relative;\n  z-index: 1;\n  width: 30px;\n  height: 30px;\n  min-width: 30px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  font-size: 15px;\n  line-height: 1;\n}\n\n/* Stage color = circle + icon + connector; status text stays neutral grey (see .pq-wf-sub-*) */\n.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-done {\n  background: #e6f4ea;\n  color: #1e8e3e;\n  border: 1px solid #34a853;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-done i {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-progress {\n  background: #f3e8ff;\n  color: #7e22ce;\n  border: 1px solid #a855f7;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-progress i {\n  font-size: 15px;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-pending {\n  background: #f3f4f6;\n  color: #9ca3af;\n  border: 1px solid #e5e7eb;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-pending i {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-current-approved {\n  background: #e6f4ea;\n  color: #1e8e3e;\n  border: 2px solid #34a853;\n}\n\n.pq-workflow-timeline--v2 .pq-workflow-dot.pq-dot-current-quoted {\n  background: #fff7ed;\n  color: #ea580c;\n  border: 2px solid #fb923c;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-body {\n  min-width: 0;\n  flex: 1;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #111827;\n  line-height: 1.35;\n  margin-top: 0;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-title--muted {\n  color: black;\n  font-weight: 600;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-sub {\n  font-size: 13px;\n  margin-top: 3px;\n  line-height: 1.35;\n}\n\n/* Status caption under title: neutral grey (stage color is on the dot + line only) */\n.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-completed {\n  color: #16a34a !important;\n  font-weight: 400;\n  letter-spacing: 0.05rem;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-progress {\n  color: black !important;\n  font-weight: 400;\n  padding-top: 3px;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-current-green {\n  color: #16a34a !important;\n  font-weight: 400;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-current-orange {\n  color: #ea580c !important;\n  font-weight: 500;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-sub.pq-wf-sub-pending {\n  color: black !important;\n  font-weight: 500;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-extra {\n  font-size: 12px;\n  color: black !important;\n  margin-top: 6px;\n  line-height: 1.4;\n}\n\n.pq-workflow-timeline--v2 .pq-wf-link-row {\n  font-size: 12px;\n  color: black !important;\n  margin-top: 6px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.pq-workflow-timeline--v2 .pq-linked-quote-btn {\n  border: 0;\n  background: none;\n  padding: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #2563eb !important;\n  cursor: pointer;\n  text-decoration: none;\n  text-underline-offset: 2px;\n}\n\n.pq-workflow-timeline--v2 .pq-linked-quote-btn:hover {\n  color: #1d4ed8 !important;\n}\n\n/* Reopen project confirmation (Actions → Reopen) */\n.pq-reopen-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.45);\n  backdrop-filter: blur(2px);\n}\n\n.pq-reopen-modal {\n  width: 100%;\n  max-width: 480px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);\n  border: 1px solid #e5e7eb;\n  padding: 24px 24px 20px;\n}\n\n.pq-reopen-modal__header {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.pq-reopen-modal__icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: 999px;\n  background: linear-gradient(145deg, #fb923c 0%, #ea580c 100%);\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  line-height: 1;\n}\n\n.pq-reopen-modal__title {\n  margin: 4px 0 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.25;\n}\n\n.pq-reopen-modal__body {\n  margin: 0 0 22px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #475569;\n}\n\n.pq-reopen-modal__footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.pq-reopen-modal__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 0 18px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.pq-reopen-modal__btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.pq-reopen-modal__btn--secondary {\n  background: #ffffff;\n  border-color: #d1d5db;\n  color: #111827;\n}\n\n.pq-reopen-modal__btn--secondary:hover:not(:disabled) {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.pq-reopen-modal__btn--primary {\n  background: linear-gradient(145deg, #fb923c 0%, #ea580c 100%);\n  border-color: #ea580c;\n  color: #ffffff;\n}\n\n.pq-reopen-modal__btn--primary:hover:not(:disabled) {\n  filter: brightness(1.03);\n}\n\n.pq-reopen-modal__btn--primary i {\n  font-size: 18px;\n}\n\n/* Signage project view — attachment actions + pending proof groups (conversation / shared files) */\n.pq-attachment-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.pq-attachment-view.pq-attachment-download {\n  color: #2563eb;\n  border-color: #bfdbfe;\n  background: #eff6ff;\n}\n\n.pq-attachment-view.pq-attachment-download:hover {\n  background: #dbeafe;\n  border-color: #93c5fd;\n}\n\n.pq-proof-group-head--proof-pending {\n  justify-content: flex-start;\n}\n\n.pq-proof-group-head-proof-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.pq-proof-group-head-count {\n  font-weight: 700;\n  color: #4338ca;\n}\n\n/* Quick Actions — SELECT PROOF VERSION (premium: card lift, blue selection block, white pills) */\n.pq-side-box.pq-proof-version-card {\n  padding: 0;\n  overflow: hidden;\n  border-radius: 14px;\n  border: 1px solid #e4e9f0;\n  background: #fff;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.04),\n    0 4px 16px rgba(15, 23, 42, 0.06);\n}\n\n.pq-proof-version-card-head {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: #3730a3;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 18px;\n  margin: 0;\n  border-bottom: 1px solid #e8ecf1;\n  background: linear-gradient(to right, #eef2ff, #f5f8ff);\n}\n\n.pq-proof-version-card-head i {\n  font-size: 17px;\n  color: #3730a3;\n}\n\n.pq-proof-version-empty {\n  padding: 20px 18px 16px;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.pq-proof-version-list {\n  list-style: none;\n  margin: 0;\n  padding: 14px 12px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pq-proof-version-item {\n  margin: 0;\n}\n\n.pq-proof-version-label {\n  display: grid;\n  grid-template-columns: 30px 1fr;\n  gap: 16px;\n  align-items: start;\n  padding: 18px 16px 20px;\n  margin: 0;\n  cursor: pointer;\n  border-radius: 12px;\n  border: 1px solid #eceff4;\n  background: #fff;\n  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);\n  transition:\n    background 0.18s ease,\n    border-color 0.18s ease,\n    box-shadow 0.18s ease;\n}\n\n.pq-proof-version-label:hover:not(.is-approved):not(.is-selected) {\n  border-color: #dde3eb;\n  background: #fbfcfe;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\n}\n\n.pq-proof-version-label.is-selected {\n  background: #f0f7ff;\n  border-color: #b6d2f7;\n  box-shadow:\n    0 0 0 1px rgba(37, 99, 235, 0.12),\n    0 4px 14px rgba(37, 99, 235, 0.08);\n}\n\n.pq-proof-version-label.is-approved {\n  cursor: default;\n  border-color: #eceff4;\n  background: #fff;\n  opacity: 1;\n}\n\n.pq-proof-version-label.is-approved:hover {\n  border-color: #eceff4;\n  background: #fff;\n  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);\n}\n\n.pq-proof-version-radio-cell {\n  position: relative;\n  width: 30px;\n  height: 26px;\n  flex-shrink: 0;\n}\n\n.pq-proof-version-radio-input {\n  position: absolute;\n  left: 0;\n  top: 2px;\n  width: 24px;\n  height: 24px;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.pq-proof-version-label.is-approved .pq-proof-version-radio-input {\n  cursor: not-allowed;\n}\n\n.pq-proof-version-radio-faux {\n  position: relative;\n  display: block;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid #c5cdd8;\n  background: #fff;\n  pointer-events: none;\n  transition:\n    border-color 0.18s ease,\n    box-shadow 0.18s ease;\n  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.9);\n}\n\n.pq-proof-version-label.is-selected .pq-proof-version-radio-faux {\n  border-color: #2563eb;\n  box-shadow:\n    inset 0 0 0 5px #fff,\n    inset 0 0 0 14px #2563eb,\n    0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n.pq-proof-version-label.is-approved .pq-proof-version-radio-faux {\n  border-color: #16a34a;\n  background: #fff;\n  box-shadow: none;\n}\n\n.pq-proof-version-label.is-approved .pq-proof-version-radio-faux::after {\n  content: \"✓\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -56%);\n  color: #16a34a;\n  font-size: 15px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.pq-proof-version-radio-input:focus-visible+.pq-proof-version-radio-faux {\n  outline: 2px solid #3b82f6;\n  outline-offset: 3px;\n}\n\n.pq-proof-version-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n}\n\n.pq-proof-version-title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  width: 100%;\n}\n\n.pq-proof-version-title {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0c1222;\n  letter-spacing: -0.02em;\n  line-height: 1.35;\n}\n\n.pq-proof-version-label.is-selected .pq-proof-version-title {\n  color: #0f172a;\n}\n\n.pq-proof-version-file-count {\n  flex-shrink: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n  padding-top: 1px;\n  letter-spacing: -0.01em;\n}\n\n.pq-proof-version-approved-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0;\n  border-radius: 0;\n  background: transparent;\n  border: 0;\n  color: #16a34a;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0;\n}\n\n.pq-proof-version-approved-tag-btn {\n  gap: 5px;\n  height: 32px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 0;\n  background: #16a34a;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.pq-proof-version-approved-tag-btn:hover:not(:disabled) {\n  background: #15803d;\n}\n\n.pq-proof-version-approved-tag-btn i {\n  font-size: 15px;\n}\n\n.pq-proof-version-approved-tag-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.75;\n}\n\n.pq-proof-version-chips {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n  width: 100%;\n}\n\n.pq-proof-version-chip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  min-width: 0;\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #1e293b;\n  letter-spacing: -0.01em;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease,\n    background 0.15s ease;\n}\n\n.pq-proof-version-label.is-selected .pq-proof-version-chip {\n  border-color: #c5daf7;\n  background: #fff;\n  box-shadow:\n    0 1px 2px rgba(37, 99, 235, 0.06),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.pq-proof-version-chip i {\n  font-size: 16px;\n  color: #64748b;\n  flex-shrink: 0;\n  opacity: 0.92;\n}\n\n.pq-proof-version-chip-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1.4;\n}\n\n.pq-proof-version-card .pq-proof-version-submit.pq-full-btn {\n  width: calc(100% - 32px);\n  margin: 8px 16px 18px;\n  height: 48px;\n  border-radius: 12px;\n  background: #fff;\n  border: 1.5px solid #3b82f6;\n  color: #1d4ed8;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: -0.02em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.12);\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease,\n    box-shadow 0.15s ease,\n    color 0.15s ease;\n}\n\n.pq-proof-version-card .pq-proof-version-submit.pq-full-btn:hover:not(:disabled) {\n  background: #eff6ff;\n  border-color: #2563eb;\n  color: #1e40af;\n  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.18);\n}\n\n.pq-proof-version-card .pq-proof-version-submit.pq-full-btn i {\n  font-size: 20px;\n  color: #2563eb;\n}\n.pq-proof-version-card .pq-proof-version-submit.pq-full-btn:hover i {\n  font-size: 20px;\n  color: white;\n}\n\n.pq-proof-version-card .pq-proof-version-submit.pq-full-btn.pq-btn-disabled {\n  border-color: #cbd5e1;\n  color: #94a3b8;\n  box-shadow: none;\n}\n\n.pq-proof-version-card .pq-proof-version-submit.pq-full-btn.pq-btn-disabled i {\n  color: #94a3b8;\n}\n\n.pq-side-title--quick-actions::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #2563eb;\n  flex-shrink: 0;\n  margin-right: 2px;\n}\n\n/* Composer outer frame (replaces inline styles; margins scale on narrow viewports) */\n.pq-composer-border-wrap {\n  box-sizing: border-box;\n  margin: 0 clamp(0px, 2vw, 10px) 20px;\n  border: 1px solid #e5e7eb;\n  border-radius: 15px;\n  overflow: hidden;\n}\n\n/* ---- Signage project view — mobile / narrow viewport (must stay last to win cascade) ---- */\n@media (max-width: 768px) {\n  .pq-page-subtitle {\n    margin-left: 0 !important;\n  }\n\n  .pq-view-title-row {\n    align-items: flex-start;\n  }\n\n  .pq-view-head .pq-actions-wrap {\n    width: 100%;\n  }\n\n  .pq-view-head .pq-ref-actions {\n    width: 100%;\n    min-height: 44px;\n    justify-content: center;\n  }\n\n  .pq-agent-grid-top {\n    grid-template-columns: 1fr !important;\n    gap: 16px;\n  }\n\n  .pq-agent-item {\n    padding: 14px 12px;\n  }\n\n  .pq-additional-details-row {\n    justify-content: center !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .pq-additional-btn {\n    width: min(100%, 360px) !important;\n    min-height: 44px;\n    margin-left: auto !important;\n    margin-right: auto !important;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .pq-expand-details .row.justify-content-end {\n    justify-content: center !important;\n    margin-right: 0 !important;\n  }\n\n  .pq-agent-address-section.px-4 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .pq-agent-address-row--city-state-zip {\n    grid-template-columns: 1fr;\n    gap: 14px;\n  }\n\n  .pq-meta-row {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .pq-k {\n    font-size: 0.9375rem;\n    line-height: 1.35;\n  }\n\n  .pq-v {\n    font-size: 1rem;\n    line-height: 1.45;\n    word-break: break-word;\n  }\n\n  .pq-convo-bubble-wrap {\n    margin-left: 0 !important;\n    width: 100% !important;\n    max-width: 100%;\n  }\n\n  .pq-convo-item .pq-attachment {\n    width: 100%;\n  }\n\n  /* Keep Conversation + Shared Files on one row; scroll if needed; Mute tucks on the right. */\n  .pq-tabs-with-right {\n    flex-wrap: nowrap;\n    align-items: stretch;\n    gap: 0;\n    padding: 0 12px;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: thin;\n  }\n\n  .pq-tab {\n    flex: 0 0 auto;\n    justify-content: center;\n    min-height: 48px;\n    padding: 0 12px;\n    font-size: 13px;\n  }\n\n  .pq-mute-btn {\n    flex: 0 0 auto;\n    margin-left: auto;\n    min-height: 44px;\n    padding: 0 10px;\n    align-self: center;\n  }\n\n  .pq-msg-proof-approved-head {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .pq-msg-proof-approved-head-left {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .pq-msg-proof-by {\n    white-space: normal;\n    align-self: center;\n    text-align: center;\n  }\n\n  .pq-msg-proof-by--stack {\n    align-items: center;\n    align-self: center;\n    text-align: center;\n  }\n\n  .pq-msg-proof-by-line {\n    text-align: center;\n  }\n\n  .pq-msg-proof-row--rich .pq-msg-proof-row-top {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  /* Filename must not shrink in flex (was breaking one character per line). */\n  .pq-msg-proof-approved,\n  .pq-msg-proof-rows,\n  .pq-msg-proof-row--rich,\n  .pq-msg-proof-row--rich .pq-msg-proof-row-inner {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .pq-msg-proof-row--rich .pq-msg-proof-row-main {\n    flex-wrap: wrap;\n    width: 100%;\n    align-content: flex-start;\n  }\n\n  .pq-msg-proof-row--rich .pq-msg-proof-row-main>.pq-msg-proof-row-name {\n    flex: 1 1 100%;\n    min-width: 0;\n    max-width: 100%;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n    word-break: break-word;\n    overflow-wrap: break-word;\n  }\n\n  .pq-msg-proof-row-actions {\n    align-self: flex-end;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 10px;\n    width: 100%;\n  }\n\n  .pq-msg-proof-row-view,\n  .pq-msg-proof-row-download {\n    width: 44px;\n    height: 44px;\n  }\n\n  .pq-msg-proof-row-sub--enduser {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .pq-msg-proof-row-sub--enduser .pq-msg-proof-row-sub-ico {\n    margin-top: 0;\n  }\n\n  .pq-msg-proof-row-sub-meta {\n    margin-left: 0;\n  }\n\n  .pq-msg-proof-row-sub:not(.pq-msg-proof-row-sub--enduser) {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n\n  .pq-msg-proof-row-sub:not(.pq-msg-proof-row-sub--enduser) .pq-msg-proof-row-sub-dot {\n    display: none;\n  }\n\n  .pq-file-actions {\n    gap: 12px;\n  }\n\n  .pq-file-actions .pq-file-action-btn {\n    min-width: 44px;\n    min-height: 44px;\n    padding: 8px;\n    box-sizing: border-box;\n  }\n\n  .pq-convo-list,\n  .pq-shared-files {\n    max-height: min(420px, 50vh);\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n\n  .pq-composer-border-wrap {\n    margin-left: 0;\n    margin-right: 0;\n    border-radius: 12px;\n  }\n\n  .pq-workflow-timeline--v2 .pq-wf-title {\n    font-size: 15px;\n  }\n\n  .pq-workflow-timeline--v2 .pq-wf-sub {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .pq-back-link {\n    min-height: 44px;\n    padding: 6px 4px 6px 0;\n    align-items: center;\n  }\n\n  .pq-status-pill {\n    min-height: 32px;\n    padding: 4px 12px;\n  }\n}\n\n.w-60 {\n  width: 60%;\n}\n\n@media (max-width :769px) {\n  .w-60 {\n    width: 100%;\n  }\n}\n\n/* Approved proof — internal order summary (below order details) */\n.pq-proof-order-summary {\n  border-top: 1px solid #e5e7eb;\n  background: #fff;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.pq-proof-order-summary-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 16px 8px;\n}\n\n.pq-proof-order-summary-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #374151;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.pq-proof-order-summary-icon {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n  flex-shrink: 0;\n  display: block;\n}\n\n.pq-proof-order-summary-hint {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.pq-proof-order-summary-view-wrap,\n.pq-proof-order-summary-edit-wrap {\n  padding: 0 16px 14px;\n}\n\n.pq-proof-order-summary-view {\n  position: relative;\n  background: #fafafa;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 12px 14px;\n}\n\n.pq-proof-order-summary-text {\n  margin: 0;\n  padding-right: 28px;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n.pq-proof-order-summary-edit-btn {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  border: none;\n  background: transparent;\n  color: #9ca3af;\n  border-radius: 6px;\n  padding: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pq-proof-order-summary-edit-btn:hover {\n  color: #374151;\n  background: #f3f4f6;\n}\n\n.pq-proof-order-summary-textarea {\n  width: 100%;\n  min-height: 90px;\n  padding: 12px 14px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 8px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.6;\n  resize: vertical;\n  background: #fff;\n  box-sizing: border-box;\n}\n\n.pq-proof-order-summary-textarea:focus {\n  outline: none;\n  border-color: #6b7280;\n}\n\n.pq-proof-order-summary-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 8px;\n  flex-wrap: wrap;\n}\n\n.pq-proof-order-summary-foot-hint {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.pq-proof-order-summary-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-left: auto;\n}\n\n.pq-proof-order-summary-cancel-btn {\n  padding: 5px 12px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.pq-proof-order-summary-cancel-btn:hover:not(:disabled) {\n  background: #f9fafb;\n}\n\n.pq-proof-order-summary-save-btn {\n  padding: 5px 14px;\n  border-radius: 6px;\n  border: none;\n  background: #2563eb;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: \"Roboto\", sans-serif;\n}\n.pq-proof-order-summary-save-btn:hover {\n  background: #1d4ed8;\n}\n\n.pq-proof-order-summary-save-btn:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n.pq-proof-order-summary-save-btn:disabled,\n.pq-proof-order-summary-cancel-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
